var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
/* eslint no-return-await: 0, no-shadow: 0 */
import _ from 'underscore';
import axios from 'axios';
import request from 'superagent';
import i18next from 'i18next';
import qs from 'qs';
import assign from 'object-assign';
import fileDownload from 'js-file-download';
import { showToast } from 'stores/ToastStore';
import { CONFIGURED_FEATURES, featureEnabled } from 'helpers/feature-flags';
import AdminServerActionCreators from '../actions/AdminServerActionCreators';
import client from './rest/AdminClient';
import SessionStore from '../stores/SessionStore';
import AdminAppDispatcher from '../dispatcher/AdminAppDispatcher';
import AdminConstants from '../constants/AdminConstants';
import DocumentsWebAPIUtils from './DocumentsWebAPIUtils';
import ShipmentsActionCreators from '../actions/ShipmentsActionCreators';
import { ADD_POD, ADD_DOCUMENTS, COMPLETE_STOP, CONFIRM_APPT, ENTER_REQUIRED_DATES, SCHEDULE_APPT, } from '../constants/next-actions';
import { getBearerGrantTypeAuthHeaders } from '../helpers/auth_helpers';
import { isEmpty, isObject, isString } from 'lodash';
import { mapTags } from './formatters/tags';
const ActionTypes = AdminConstants.ActionTypes;
const queryOptions = {
    paginate: true,
    count: true,
    lean: true,
    sort: false,
    per_page: 25,
    populate: [
        {
            path: 'stops',
            populate: {
                path: 'equipments',
            },
        },
        { path: 'shipper' },
        { path: 'carrier' },
        { path: 'driver' },
        { path: 'order' },
    ],
};
const exportCsvQueryOptions = {
    paginate: true,
    per_page: 1000,
};
const getStopAuditEvents = (id) => client({
    method: 'GET',
    path: `/api/audits/stops/${id}`,
});
const getShipmentAuditEvents = (id) => client({
    method: 'GET',
    path: `/api/audits/jobs/${id}`,
});
export const addHold = async (shipmentId, hold) => {
    const response = await client({
        method: 'POST',
        path: `/admin/api/v3/jobs/${shipmentId}/holds`,
        entity: JSON.stringify(hold),
    }).catch((response) => {
        showToast('Failed to add hold', i18next.t('FAILED_TO_ADD_HOLD', { error: response.entity.error }), 'error');
    });
    if (response) {
        showToast('Hold added successfully', i18next.t('HOLD_ADDED_SUCCESSFULLY', { hold_type: hold.type }), 'success');
        return response.entity;
    }
};
export const updateHold = async (shipmentId, hold) => {
    const response = await client({
        method: 'PUT',
        path: `/admin/api/v3/jobs/${shipmentId}/holds/${hold._id}`,
        entity: JSON.stringify(hold),
    }).catch((response) => {
        showToast('Failed to add hold', i18next.t('FAILED_TO_UPDATE_HOLD', { error: response.entity.error }), 'error');
    });
    if (response) {
        showToast('Hold updated successfully', i18next.t('HOLD_UPDATED_SUCCESSFULLY', { hold_type: hold.type }), 'success');
        return response.entity;
    }
};
export const processBulkBol = async (jobsData) => {
    return await client({
        method: 'POST',
        path: `/admin/api/v2/jobs/bulk/bol/send`,
        entity: JSON.stringify({ jobsData }),
    }).catch((response) => {
        showToast('Failed to send Bill of Lading', i18next.t('FAILED_TO_SEND_BOL', { error: response.entity.error }), 'error');
    });
};
export const getShipmentCountList = (filterMetaData) => {
    const queryString = qs.stringify(Object.assign({}, filterMetaData));
    return client({
        method: 'GET',
        path: `admin/api/jobs/audit-carrier-basecosts/shipments?${queryString}`,
    });
};
export const getLFDAlertAction = async (filterMetadata) => {
    const query = _.extend({}, filterMetadata);
    const queryString = qs.stringify(Object.assign({}, query));
    const response = await client({
        method: 'GET',
        path: '/api/jobs/actions/past-lfd?' + queryString,
    });
    return response.entity.data;
};
export const getEmptyPickupReadyAction = async (filterMetadata) => {
    const query = _.extend({}, filterMetadata);
    const queryString = qs.stringify(Object.assign({}, query));
    const response = await client({
        method: 'GET',
        path: '/api/jobs/actions/empty-pickup?' + queryString,
    });
    return response.entity.data;
};
export const triggerExportCSV = async (filterMetadata, recipients) => {
    const query = _.extend({}, filterMetadata);
    const queryString = qs.stringify(Object.assign({}, query));
    const response = await client({
        method: 'POST',
        path: '/api/jobs/actions/csv-export?' + queryString,
        entity: JSON.stringify({ recipients }),
    });
    return response.entity;
};
export const getShipmentModifiedDate = async (shipmentId) => {
    return axios({
        method: 'get',
        url: `${API_HOST}/api/v3/jobs/${shipmentId}/modified`,
        headers: {
            'Content-Type': 'application/json',
            Authorization: getBearerGrantTypeAuthHeaders(),
        },
    });
};
export const downloadPODs = async (filters) => {
    // Blob downloads don't work with our rest client. Axios `responseType` needed.
    const response = await axios({
        method: 'post',
        url: `${API_HOST}/api/shipments/pods/archive`,
        data: filters,
        responseType: 'blob',
        headers: {
            'Content-Type': 'application/json',
            Authorization: getBearerGrantTypeAuthHeaders(),
        },
    });
    fileDownload(response.data, 'pods.zip', 'application/zip');
};
export const getNextActions = async ({ per_page, page, sort, sort_dir, filterMetadata, cancelToken, }) => {
    let missingPodData;
    let missingDocumentsData;
    if (!featureEnabled(CONFIGURED_FEATURES.SSR)) {
        const response = await getMissingPodActions({
            per_page,
            page,
            sort,
            sort_dir,
            filterMetadata,
            cancelToken,
        });
        missingPodData = response.data.data;
    }
    else {
        missingDocumentsData = await getMissingDocumentsActions({
            per_page,
            page,
            sort,
            sort_dir,
            filterMetadata,
            cancelToken,
        });
    }
    const { data: { data: completeStopData }, } = await getCompleteStopActions({
        per_page,
        page,
        sort,
        sort_dir,
        filterMetadata,
        cancelToken,
    });
    const { data: { data: confirmAppointmentData }, } = await getMissingAppointmentConfirmations({
        per_page,
        page,
        sort,
        sort_dir,
        filterMetadata,
        cancelToken,
    });
    const { data: { data: scheduleAppointmentData }, } = await getScheduleAppointmentActions({
        per_page,
        page,
        sort,
        sort_dir,
        filterMetadata,
        cancelToken,
    });
    const { data: { data: missingRequiredDatesData }, } = await getMissingRequiredDatesActions({
        per_page,
        page,
        sort,
        sort_dir,
        filterMetadata,
        cancelToken,
    });
    const combinedDataResult = {
        [COMPLETE_STOP]: completeStopData,
        [CONFIRM_APPT]: confirmAppointmentData,
        [ENTER_REQUIRED_DATES]: missingRequiredDatesData,
        [SCHEDULE_APPT]: scheduleAppointmentData,
    };
    if (!featureEnabled(CONFIGURED_FEATURES.SSR)) {
        combinedDataResult[ADD_POD] = missingPodData;
    }
    else {
        combinedDataResult[ADD_DOCUMENTS] = missingDocumentsData;
    }
    return combinedDataResult;
};
export const getMissingPodAction = async (query) => {
    const queryString = qs.stringify(Object.assign({}, query));
    const options = {
        method: 'get',
        url: `${API_HOST}/api/jobs/actions/missing-pods?${queryString}`,
        headers: {
            'Content-Type': 'application/json',
            Authorization: getBearerGrantTypeAuthHeaders(),
        },
    };
    return axios(options);
};
const getMissingPodActions = async ({ per_page, page, sort, sort_dir, filterMetadata, cancelToken, }) => {
    const queryString = qs.stringify(Object.assign({ per_page,
        page,
        sort,
        sort_dir }, filterMetadata));
    const options = {
        method: 'get',
        url: `${API_HOST}/api/jobs/actions/missing-pods?${queryString}`,
        headers: {
            'Content-Type': 'application/json',
            Authorization: getBearerGrantTypeAuthHeaders(),
        },
    };
    if (cancelToken) {
        options.cancelToken = cancelToken;
    }
    return axios(options);
};
const getMissingDocumentsActions = async ({ per_page, page, sort, sort_dir, filterMetadata, cancelToken, }) => {
    const queryString = qs.stringify(Object.assign({ per_page,
        page,
        sort,
        sort_dir }, filterMetadata));
    const options = {
        method: 'get',
        url: `${API_HOST}/api/jobs/actions/missing-documents?${queryString}`,
        headers: {
            'Content-Type': 'application/json',
            Authorization: getBearerGrantTypeAuthHeaders(),
        },
    };
    if (cancelToken) {
        options.cancelToken = cancelToken;
    }
    const response = await axios(options);
    const responseData = response.data.data[0];
    const shipments = responseData.shipments || [];
    const shipmentsActions = shipments.map((shipment) => ({
        shipment,
        action: ADD_DOCUMENTS,
    }));
    const missingDocumentsActions = {
        total: responseData.total,
        pages: Math.ceil(responseData.total / per_page),
        actions: shipmentsActions,
    };
    return missingDocumentsActions;
};
const getCompleteStopActions = async ({ per_page, page, sort, sort_dir, filterMetadata, cancelToken, }) => {
    const queryString = qs.stringify(Object.assign({ per_page,
        page,
        sort,
        sort_dir }, filterMetadata));
    const options = {
        method: 'get',
        url: `${API_HOST}/api/jobs/actions/complete-stops?${queryString}`,
        headers: {
            'Content-Type': 'application/json',
            Authorization: getBearerGrantTypeAuthHeaders(),
        },
    };
    if (cancelToken) {
        options.cancelToken = cancelToken;
    }
    return axios(options);
};
const getMissingRequiredDatesActions = async ({ per_page, page, sort, sort_dir, filterMetadata, cancelToken, }) => {
    const queryString = qs.stringify(Object.assign({ per_page,
        page,
        sort,
        sort_dir }, filterMetadata));
    const options = {
        method: 'get',
        url: `${API_HOST}/api/jobs/actions/missing-required-dates?${queryString}`,
        headers: {
            'Content-Type': 'application/json',
            Authorization: getBearerGrantTypeAuthHeaders(),
        },
    };
    if (cancelToken) {
        options.cancelToken = cancelToken;
    }
    return axios(options);
};
export async function getUnprocessedCarrierBaseCosts({ per_page, page, sort, sort_dir, filterMetadata, cancelToken, }) {
    const queryString = qs.stringify(Object.assign({ per_page,
        page,
        sort,
        sort_dir }, filterMetadata));
    const options = {
        method: 'get',
        url: `${API_HOST}/admin/api/jobs/audit-carrier-basecosts?${queryString}`,
        headers: {
            'Content-Type': 'application/json',
            Authorization: getBearerGrantTypeAuthHeaders(),
        },
    };
    if (cancelToken) {
        options.cancelToken = cancelToken;
    }
    return axios(options);
}
export async function getMissingAppointmentConfirmations({ per_page, page, sort, sort_dir, filterMetadata, cancelToken, }) {
    const queryString = qs.stringify(Object.assign({ per_page,
        page,
        sort,
        sort_dir }, filterMetadata));
    const options = {
        method: 'get',
        url: `${API_HOST}/api/jobs/actions/missing-appointment-confirmations?${queryString}`,
        headers: {
            'Content-Type': 'application/json',
            Authorization: getBearerGrantTypeAuthHeaders(),
        },
    };
    if (cancelToken) {
        options.cancelToken = cancelToken;
    }
    return axios(options);
}
export async function getScheduleAppointmentActions({ per_page, page, sort, sort_dir, filterMetadata, cancelToken, }) {
    const queryString = qs.stringify(Object.assign({ per_page,
        page,
        sort,
        sort_dir }, filterMetadata));
    const options = {
        method: 'get',
        url: `${API_HOST}/api/jobs/actions/schedule-appointment?${queryString}`,
        headers: {
            'Content-Type': 'application/json',
            Authorization: getBearerGrantTypeAuthHeaders(),
        },
    };
    if (cancelToken) {
        options.cancelToken = cancelToken;
    }
    return axios(options);
}
export async function postCarrierBulkApproveRates(selectedRates) {
    const response = await client({
        method: 'POST',
        path: `/admin/api/jobs/audit-carrier-basecosts/approve`,
        entity: JSON.stringify(selectedRates),
    });
    return response.entity;
}
export async function getUnprocessedShipmentList({ filterMetadata, options }) {
    const queryString = qs.stringify(Object.assign(Object.assign({}, filterMetadata), options));
    const response = await client({
        method: 'GET',
        path: `/admin/api/jobs/audit-carrier-basecosts/shipments?${queryString}`,
    });
    const { entity: { data }, } = response;
    return data;
}
export async function bulkEditCarrierRate(bulkAdjustmentMetaData) {
    const queryString = qs.stringify(Object.assign({}, bulkAdjustmentMetaData));
    const response = await client({
        method: 'POST',
        path: `/admin/api/jobs/audit-carrier-basecosts/update-carrier-rate?${queryString}`,
    });
    const { entity: { data }, } = response;
    return data;
}
const isMasterAccountUser = () => {
    return SessionStore.isMasterAccountUser();
};
const getShipmentsLegacy = function (filters) {
    if (isMasterAccountUser()) {
        filters.is_master_account = true;
    }
    const query = _.extend({}, queryOptions, filters);
    const queryString = qs.stringify(Object.assign(Object.assign({}, query), { _: new Date().getTime() }));
    return client({ method: 'GET', path: '/api/v2/jobs?' + queryString });
};
const getLFDShipments = function (filters) {
    const query = _.extend({}, queryOptions, filters);
    const queryString = qs.stringify(Object.assign({}, query));
    return client({
        method: 'GET',
        path: '/api/v2/jobs/bulk-lfd?' + queryString,
    });
};
export const getShipmentsByReferenceNumber = function (filters) {
    const { _id: id, _type: userType } = SessionStore.getUser();
    const query = _.extend({}, filters);
    query[userType.toLowerCase()] = id;
    const queryString = qs.stringify(Object.assign({}, query));
    return client({
        method: 'GET',
        path: '/api/v2/jobs/reference-search?' + queryString,
    });
};
export const getShipments = function (filters) {
    if (isMasterAccountUser()) {
        filters.is_master_account = true;
    }
    const query = _.extend({}, filters, {
        _: new Date().getTime(),
    });
    return client({
        method: 'POST',
        path: '/api/v3/jobs',
        entity: JSON.stringify(query),
    });
};
export function getShipmentsWithDetails(filters) {
    if (isMasterAccountUser()) {
        filters.is_master_account = true;
    }
    const query = _.extend({}, filters, {
        _: new Date().getTime(),
    });
    return client({
        method: 'POST',
        path: '/api/v3/jobs/details',
        entity: JSON.stringify(query),
    });
}
export const getShipmentsForExportDocs = function (filters) {
    const query = _.extend({}, filters, {
        _: new Date().getTime(),
    });
    return client({
        method: 'POST',
        path: '/api/v3/jobs-for-export-docs',
        entity: JSON.stringify(query),
    });
};
const getShipmentsForCsv = function (filters, columns) {
    const query = _.extend({}, filters, exportCsvQueryOptions);
    query.columns = columns;
    const queryString = qs.stringify(query);
    return client({
        method: 'POST',
        path: '/api/v2/jobs/csv-from-query?' + queryString,
    });
};
const transitionStop = function (shipment, stop, workflow, meta) {
    const updates = {
        event: workflow,
        meta: meta,
    };
    return client({
        method: 'POST',
        path: `/api/v2/jobs/${shipment._id}/stops/${stop._id}/transition`,
        entity: JSON.stringify(updates),
    });
};
export function completeStop(shipment, stop, _pods, meta) {
    // Don't need to send pods any more, should already be in meta
    const body = {
        shipmentId: shipment._id,
        stopId: stop._id,
        meta,
    };
    return client({
        method: 'POST',
        path: '/api/v3/stops/complete',
        entity: JSON.stringify(body),
    });
}
export function podEmailOnPodUpload(shipment, document) {
    // Don't need to send pods any more, should already be in meta
    const body = {
        job: shipment,
        document,
    };
    return client({
        method: 'POST',
        path: '/api/v3/stops/podEmail',
        entity: JSON.stringify(body),
    });
}
const completeMassStops = function (shipments) {
    return client({
        method: 'POST',
        path: '/api/v2/jobs/bulk/stops/complete',
        entity: JSON.stringify(shipments),
    });
};
const arrivedMassStops = function (shipments) {
    return client({
        method: 'POST',
        path: '/api/v2/jobs/bulk/stops/arrived',
        entity: JSON.stringify(shipments),
    });
};
const updateShipmentStop = function (shipment, stop, updates) {
    return client({
        method: 'PATCH',
        path: `/admin/api/v2/jobs/${shipment._id}/stops/${stop._id}`,
        entity: JSON.stringify(updates),
    });
};
export const updateShipmentStopEquipment = function (shipment, stop, updates, isCarrier = false, carrierPartner = null) {
    let path;
    if (isCarrier) {
        path = `/api/v2/jobs/${shipment._id}/stops/${stop._id}/equipment`;
    }
    else {
        path = `/admin/api/v2/jobs/${shipment._id}/stops/${stop._id}/equipment`;
    }
    if (carrierPartner) {
        updates.carrierPartner = carrierPartner;
    }
    return client({
        method: 'PUT',
        path,
        entity: JSON.stringify(updates),
    });
};
export function handleStopEquipmentUpdateSuccess({ job }) {
    AdminServerActionCreators.receiveShipmentSuccess({ job });
    AdminServerActionCreators.updateStopEquipmentsSuccess(job);
}
export function handleStopEquipmentUpdateFail(res) {
    AdminServerActionCreators.updateStopEquipmentsFail(res.entity);
    console.error('response fail', res);
}
const updateShipmentStopLoads = function (shipment, stop, updates) {
    return client({
        method: 'PUT',
        path: `/admin/api/v2/jobs/${shipment._id}/stops/${stop._id}/loaddetails`,
        entity: JSON.stringify(updates),
    });
};
const updateOnHold = function (shipment, on_hold, on_hold_description, on_hold_reason) {
    const updates = { on_hold, on_hold_description, on_hold_reason };
    return client({
        method: 'PUT',
        path: `/admin/api/v2/jobs/${shipment._id}/onhold`,
        entity: JSON.stringify(updates),
    });
};
const updateExposed = function (shipment, exposed) {
    const updates = { exposed };
    return client({
        method: 'PUT',
        path: `/admin/api/v2/jobs/${shipment._id}/exposed`,
        entity: JSON.stringify(updates),
    });
};
const updateShipmentStopAttempt = function (shipment, stop, data) {
    return client({
        method: 'PUT',
        path: `/admin/api/v2/jobs/${shipment._id}/stops/${stop._id}/attempt`,
        entity: JSON.stringify(data),
    });
};
const updateShipmentStopLocation = function (shipment, stop, updates) {
    return client({
        method: 'PUT',
        path: `/admin/api/v2/jobs/${shipment._id}/stops/${stop._id}/location`,
        entity: JSON.stringify(updates),
    });
};
const updateShipmentStopReferenceNumbers = function (shipment, stop, updates) {
    return client({
        method: 'PUT',
        path: `/admin/api/v2/jobs/${shipment._id}/stops/${stop._id}/references`,
        entity: JSON.stringify(updates),
    });
};
const updateStopSequences = function (shipment, sequences) {
    return client({
        method: 'PATCH',
        path: `/admin/api/v2/jobs/${shipment._id}/stops/sequences`,
        entity: JSON.stringify({ sequences }),
    });
};
const createOffer = function (offer) {
    return client({
        method: 'POST',
        path: '/api/v2/offers',
        entity: JSON.stringify(offer),
    });
};
export const createQuote = function (quote) {
    return client({
        method: 'POST',
        path: '/api/1/quotes',
        entity: JSON.stringify(quote),
    });
};
const updateQuote = function (quote) {
    const quoteId = quote._id;
    return client({
        method: 'PATCH',
        path: `/api/1/quotes/${quoteId}`,
        entity: JSON.stringify(quote),
    });
};
const deleteQuote = function (quoteId) {
    return client({
        method: 'DELETE',
        path: `/api/1/quotes/${quoteId}`,
    });
};
const getShipmentTemplates = (params = {}) => {
    const query = Object.assign({}, params);
    const queryString = qs.stringify(query);
    return client({
        method: 'GET',
        path: `/admin/api/shipment-templates?${queryString}`,
    });
};
const getShipmentTemplate = (templateId) => {
    return client({
        method: 'GET',
        path: `/admin/api/shipment-templates/${templateId}`,
    });
};
const saveTemplateAndBookShipments = (orderId, templateId, name, bookingRequest) => client({
    method: 'POST',
    path: `/admin/api/shipment-templates/${orderId}/book`,
    entity: JSON.stringify(Object.assign({ templateId,
        name }, bookingRequest)),
});
const createShipmentsAndTemplate = (orderId, name, bookingRequest) => client({
    method: 'POST',
    path: `/admin/api/shipment-templates/${orderId}/book`,
    entity: JSON.stringify(Object.assign({ name }, bookingRequest)),
});
export const createOrderShipment = function (offer) {
    return client({
        method: 'POST',
        path: '/api/v3/offers',
        entity: JSON.stringify(offer),
    });
};
export const bookMultipleOrderShipments = function (orderId, bookingRequest) {
    return client({
        method: 'POST',
        path: `/admin/api/v1/orders/${orderId}/jobs/free-flow`,
        entity: JSON.stringify(bookingRequest),
    });
};
const shareShipment = function (jobId, payload) {
    return client({
        method: 'POST',
        path: `/api/1/jobs/${jobId}/share`,
        entity: JSON.stringify(payload),
    });
};
function transformInboundShipments(shipments) {
    const items = shipments;
    const convertBoxes = (item) => {
        if (item && item.boxes) {
            return [item.boxes];
        }
        return [];
    };
    // Helper function to strip out noise _id properties
    const stripNoiseIds = (obj) => {
        if (!obj || typeof obj !== 'object')
            return obj;
        const cleaned = Object.assign({}, obj);
        // Strip out reference_numbers._id
        if (cleaned.reference_numbers && Array.isArray(cleaned.reference_numbers)) {
            cleaned.reference_numbers = cleaned.reference_numbers.map((ref) => {
                const { _id } = ref, rest = __rest(ref, ["_id"]);
                return rest;
            });
        }
        // Strip out shipper.notification_preferences._id
        if (cleaned.shipper &&
            cleaned.shipper.notification_preferences &&
            Array.isArray(cleaned.shipper.notification_preferences)) {
            cleaned.shipper = Object.assign(Object.assign({}, cleaned.shipper), { notification_preferences: cleaned.shipper.notification_preferences.map((pref) => {
                    const { _id } = pref, rest = __rest(pref, ["_id"]);
                    return rest;
                }) });
        }
        return cleaned;
    };
    const convertedItems = items.map((item) => {
        const transformed = Object.assign(Object.assign({}, item), {
            boxes: convertBoxes(item),
        });
        // Strip out noise _id properties
        return stripNoiseIds(transformed);
    });
    return convertedItems;
}
function getAccountAccessRequestCount(userId) {
    return client({
        method: 'POST',
        path: `api/1/users/access/requests`,
        entity: JSON.stringify({ grantor: userId, status: 'pending' }),
    });
}
function setAccountAccessRequestApprove(requestId, grantorId, granteeUserAccountId, grantorEmail, grantData) {
    return client({
        method: 'POST',
        path: `/api/1/users/access/approve`,
        entity: JSON.stringify({
            requestId,
            grantorId,
            granteeUserAccountId,
            grantorEmail,
            grantData,
        }),
    });
}
function setAccountAccessRequestDecline(requestId, grantorId, granteeUserAccountId, grantorEmail, grantData) {
    return client({
        method: 'POST',
        path: `/api/1/users/access/decline`,
        entity: JSON.stringify({
            requestId,
            granteeUserAccountId,
            grantorId,
            grantorEmail,
            grantData,
        }),
    });
}
export function getDistance(query) {
    const queryString = qs.stringify(query);
    return client({
        method: 'GET',
        path: `/api/1/jobs/distance?${queryString}`,
    });
}
export function getDistanceV3(query) {
    const queryString = qs.stringify(query);
    return client({
        method: 'GET',
        path: `/api/3/jobs/distance?${queryString}`,
    });
}
export function getDistanceV2(offer) {
    return client({
        method: 'POST',
        path: `/api/2/jobs/distance`,
        entity: JSON.stringify({
            stops: offer.stops,
            shipper: (offer === null || offer === void 0 ? void 0 : offer.shipperId) || '',
        }),
    });
}
function getShipmentLegacy(id, isAdmin) {
    let path = `/api/1/jobs/${id}`;
    if (isAdmin) {
        path = `/admin${path}`;
    }
    return client({
        method: 'GET',
        path,
    });
}
export function getShipment(id, options = {}) {
    return client({
        method: 'GET',
        path: `/api/v3/jobs/${id}?${qs.stringify(options)}`,
    });
}
export async function getShipmentWithMapping(id, options = {}) {
    const response = await client({
        method: 'GET',
        path: `/api/v3/jobs/${id}?${qs.stringify(options)}`,
    });
    return transformInboundShipments([response.entity.item])[0];
}
function closeShipment(shipment, meta) {
    const path = `/admin/api/v2/jobs/${shipment._id}/close`;
    return client({
        method: 'POST',
        path,
        entity: JSON.stringify(meta),
    });
}
function validateShipmentId(shipmentId) {
    if (!isString(shipmentId) || isEmpty(shipmentId)) {
        throw new Error('missing shipment id');
    }
}
function validateUpdates(updates) {
    if (!isObject(updates) || isEmpty(updates)) {
        throw new Error('missing updates');
    }
}
export function updateShipmentById(shipmentId, updates) {
    validateShipmentId(shipmentId);
    validateUpdates(updates);
    const patchPath = `/api/v2/jobs/${shipmentId}`;
    return client({
        method: 'PATCH',
        path: patchPath,
        entity: JSON.stringify(updates),
    });
}
export function updateShipmentTags(shipmentId, tags = []) {
    const updates = {
        tags: mapTags(tags),
    };
    return updateShipmentById(shipmentId, updates);
}
function requireShipment(shipment) {
    if (!isObject(shipment) || isEmpty(shipment)) {
        throw new Error('missing shipment');
    }
    validateShipmentId(shipment === null || shipment === void 0 ? void 0 : shipment._id);
}
export function updateShipment(shipment, updates = {}) {
    requireShipment(shipment);
    validateUpdates(updates);
    return updateShipmentById(shipment._id, updates);
}
/**
 * @param {{
 * _id: ObjectId,
 * chassis_in_gate: Date|null,
 * chassis_out_gate: Date|null,
 * pickup_from_exam_site: Date|null,
 * dropoff_at_exam_site: Date|null,
 * }[]} updates
 * @returns {Promise<Response>}
 */
function bulkUpdateShipmentDates(updates) {
    const postPath = `/api/v4/jobs/bulk/dates`;
    return client({
        method: 'POST',
        path: postPath,
        entity: JSON.stringify({ updates }),
    });
}
function updateShipmentDates(shipment, updates) {
    const patchPath = `/api/v2/jobs/${shipment._id}/dates`;
    return client({
        method: 'PATCH',
        path: patchPath,
        entity: JSON.stringify(updates),
    });
}
function updateShipmentStopScheduling(shipment, stop, updates) {
    const patchPath = `/api/v2/jobs/${shipment._id}/stops/${stop._id}/appointment`;
    return client({
        method: 'PUT',
        path: patchPath,
        entity: JSON.stringify(updates),
    });
}
function updateMassShipmentStopScheduling(shipments) {
    return client({
        method: 'PUT',
        path: '/admin/api/v2/jobs/bulk/stops/appointment',
        entity: JSON.stringify(shipments),
    });
}
function updateCarrier(carrier, shipments) {
    const uri = '/admin/api/v2/jobs/carrier';
    const payload = {
        jobIds: shipments.map((s) => s._id),
        carrier: carrier._id,
    };
    return client({
        method: 'PUT',
        path: uri,
        entity: JSON.stringify(payload),
    });
}
function updateShipper(shipper, shipments) {
    const uri = '/admin/api/v2/jobs/shipper';
    const payload = {
        jobIds: shipments.map((s) => s._id),
        shipper: shipper._id,
    };
    return client({
        method: 'PUT',
        path: uri,
        entity: JSON.stringify(payload),
    });
}
function updateConsignee(consignee, shipments) {
    const uri = '/admin/api/v2/jobs/consignee';
    const payload = {
        jobIds: shipments.map((s) => s._id),
        consignee: consignee._id,
    };
    return client({
        method: 'PUT',
        path: uri,
        entity: JSON.stringify(payload),
    });
}
function updateShipmentHandler(shipment, update) {
    if (update.arrival_date ||
        update.discharge_date ||
        update.custom_lfd ||
        update.last_free_date ||
        update.yard_last_free_date) {
        return updateShipmentDates(shipment, update).then(() => {
            const updatedShipment = assign(shipment, update);
            AdminServerActionCreators.receiveShipmentUpdate(updatedShipment);
        }, (response) => {
            console.error('failure', response);
        });
    }
    if (update.chassis_in_gate ||
        update.chassis_out_gate ||
        update.pickup_from_exam_site ||
        update.dropoff_at_exam_site) {
        const updatedMilestoneDates = _.pick(update, [
            'chassis_in_gate',
            'chassis_out_gate',
            'pickup_from_exam_site',
            'dropoff_at_exam_site',
        ]);
        const updates = [Object.assign({ _id: shipment._id }, updatedMilestoneDates)];
        return bulkUpdateShipmentDates(updates).then(() => {
            const updatedShipment = assign(shipment, update);
            AdminServerActionCreators.receiveShipmentUpdate(updatedShipment);
        }, (response) => {
            console.error('failure', response);
        });
    }
    updateShipment(shipment, update).then(() => {
        // Doing this because currently the entity contained in the response
        // is not as fully hydrated as the copy I already have (driver object, etc)
        const updatedShipment = assign(shipment, update);
        AdminServerActionCreators.receiveShipmentUpdate(updatedShipment);
    }, (response) => {
        console.error('failure', response);
    });
}
function generateRateConfirmation(jobId, emails, send) {
    return client({
        method: 'POST',
        path: `/admin/api/v2/jobs/${jobId}/generateRateConfirmation`,
        entity: JSON.stringify({ emails, send }),
    });
}
function sendRateConfirmation(jobId, emails, send) {
    return client({
        method: 'POST',
        path: `/api/v2/jobs/${jobId}/rate-confirmation/send`,
        entity: JSON.stringify({ emails, send }),
    });
}
export function generateAndSendBulkRateConfirmation(data) {
    return client({
        method: 'POST',
        path: `/admin/api/jobs/rate-confirmations/generate/bulk`,
        entity: JSON.stringify(data),
    });
}
export async function generateBulkShipment(file) {
    try {
        return new Promise((resolve, reject) => {
            const req = request.post(`${API_HOST}/admin/api/v2/jobs/csv/bulk`);
            req.set('Authorization', getBearerGrantTypeAuthHeaders());
            req.attach('file', file);
            req.end((err, response) => {
                if (err) {
                    if (response.type === 'application/json') {
                        showToast(i18next.t('BULK_SHIPMENT_CREATION'), i18next.t('BULK_SHIPMENT_CREATION_FAILURE', {
                            error: response.body.error,
                        }), 'error');
                        return reject(response.body.error);
                    }
                    return reject(err);
                }
                showToast(i18next.t('BULK_SHIPMENT_CREATION'), i18next.t('BULK_SHIPMENT_CREATION_SUCCESS'), 'success');
                fileDownload(response.text, 'bulk-shipment.csv');
                resolve();
            });
        });
    }
    catch (e) {
        showToast(i18next.t('FAILED_TO_UPLOAD_SHIPMENTS'), e.message, 'error');
        throw e;
    }
}
function cancelShipment(shipment, reason, comment) {
    return client({
        method: 'POST',
        path: `/api/v2/jobs/${shipment._id}/cancel`,
        entity: JSON.stringify({ reason, comment }),
    });
}
function cancelShipmentForShipper(shipment, reason, comment = '') {
    return client({
        method: 'POST',
        entity: JSON.stringify({
            reason,
            comment,
        }),
        path: `/api/v2/jobs/${shipment._id}/cancel`,
    });
}
function setCancellationReason(shipment, user, reason) {
    return client({
        method: 'PATCH',
        entity: JSON.stringify({
            canceled_by: user.username,
            cancellation_reason: reason,
        }),
        path: `/api/1/jobs/${shipment._id}`,
    });
}
function exposeOffer(shipment) {
    return client({
        method: 'POST',
        entity: JSON.stringify({
            node: 'exposed',
        }),
        path: `/api/v2/jobs/${shipment._id}/workflow`,
    });
}
function bulkAssignDriver(driver, shipments) {
    const shipmentIds = shipments.map((shipment) => {
        if (shipment._id)
            return shipment._id;
        return shipment;
    });
    return client({
        method: 'POST',
        path: '/api/v2/jobs/bulk/driver',
        entity: JSON.stringify({
            shipmentIds,
            driver: driver,
        }),
    });
}
function assignDriver(shipment, driver) {
    return client({
        method: 'POST',
        path: `/api/v2/jobs/${shipment._id}/driver`,
        entity: JSON.stringify({
            driverId: driver._id,
            _type: driver._type,
        }),
    });
}
function getShipmentSuccess(response) {
    AdminServerActionCreators.receiveAllShipments(response.entity.items);
}
function getShipmentFailure(response) {
    console.error('failed: ', response);
}
function processBol(jobId, emails, send) {
    return client({
        method: 'POST',
        path: `/api/v2/jobs/${jobId}/bol/send`,
        entity: JSON.stringify({ emails, send }),
    });
}
/**
 * @name notifyCarrierAccessorials routes to BE for decline/approve
 * @param {Object} params is an object with the following properties
 * @param {string} params.type is a string either decline or approve
 * @param {Object} job is another name for shipment object
 * @param {Object}  params.carrier user object
 * @param {string} params.jobId is the id of underlying shipment
 * @param {[Object]} params.accesorials an array of accesoiral objest
 **/
function notifyCarrierAccessorials(params) {
    return client({
        method: 'POST',
        path: '/api/1/jobs/:id/customer-accessorial/send',
        entity: JSON.stringify(params),
    });
}
function sendDeliveryOrder(jobId, emails) {
    return client({
        method: 'POST',
        path: `/admin/api/v2/jobs/${jobId}/delivery-order/send`,
        entity: JSON.stringify({ emails }),
    });
}
function addComment(id, message) {
    return client({
        method: 'POST',
        path: `/api/1/jobs/${id}/comment`,
        entity: JSON.stringify({ message }),
    });
}
function getPrice(shipment) {
    return client({
        method: 'POST',
        path: '/api/v2/jobs/price',
        entity: JSON.stringify(shipment),
    });
}
export function rerateCosts(shipment, costsToBeRerated) {
    const data = {
        shipment,
        meta: { costsToBeRerated },
    };
    return client({
        method: 'POST',
        path: '/admin/api/v2/jobs/rerate',
        entity: JSON.stringify(data),
    });
}
function addAdjustment(shipment, ledger, adjustment) {
    return client({
        method: 'POST',
        path: `/admin/api/v2/jobs/${shipment._id}/adjustments`,
        entity: JSON.stringify({ adjustment, ledger }),
    });
}
function updateVendorPayable(vendorPayableToAdjust) {
    return client({
        method: 'POST',
        path: `/admin/api/v2/jobs/${vendorPayableToAdjust.shipmentId}/vendor_adjustment`,
        entity: JSON.stringify(vendorPayableToAdjust),
    });
}
function addBaseCost(shipment_id, ledgerType, ledger) {
    return client({
        method: 'POST',
        path: `/admin/api/v3/jobs/${shipment_id}/base-cost`,
        entity: JSON.stringify({ ledger, ledgerType }),
    });
}
function addAccessorial(shipment, accessorial, meta) {
    return client({
        method: 'POST',
        path: `/admin/api/v2/jobs/${shipment._id}/accessorials`,
        entity: JSON.stringify({ accessorial, meta }),
    });
}
const removeAccessorial = function (shipment, accessorial) {
    return client({
        method: 'DELETE',
        path: `/admin/api/v2/jobs/${shipment._id}/accessorials`,
        entity: JSON.stringify({ accessorial: accessorial }),
    });
};
function bulkUpdateCarrierCosts(updates) {
    return client({
        method: 'POST',
        path: '/admin/api/v2/jobs/bulk/carrier-cost',
        entity: JSON.stringify(updates),
    });
}
function transitionTo(shipment, node, meta) {
    const data = {
        node,
        meta,
        timestamp: meta.timestamp,
    };
    return client({
        method: 'POST',
        path: `/admin/api/v2/jobs/${shipment._id}/workflow`,
        entity: JSON.stringify(data),
    });
}
function createStop(jobId, payload) {
    return client({
        method: 'POST',
        path: `api/v2/jobs/${jobId}/stops`,
        entity: JSON.stringify(payload),
    });
}
function cancelStop(job, stop) {
    return client({
        method: 'PUT',
        path: `admin/api/v2/jobs/${job._id}/stops/${stop._id}/cancel`,
    });
}
function copyStop(job, stop) {
    return client({
        method: 'POST',
        path: `admin/api/v2/jobs/${job._id}/stops/${stop._id}/copy`,
    });
}
function addStopAccessorial(shipment, stop, accessorial, meta) {
    return client({
        method: 'POST',
        path: `/admin/api/v2/jobs/${shipment._id}/stops/${stop.id}/accessorials`,
        entity: JSON.stringify({ accessorial, meta }),
    });
}
function removeStopAccessorial(shipment, stop, accessorial) {
    return client({
        method: 'DELETE',
        path: `/admin/api/v2/jobs/${shipment._id}/stops/${stop.id}/accessorials`,
        entity: JSON.stringify({ accessorial: accessorial }),
    });
}
const getTrackingShipments = async (reference) => {
    const agent = SessionStore.getUser();
    const path = agent ? `/api/jobs/tracking` : `/shipments/tracking`;
    return await client({
        method: 'POST',
        path,
        entity: JSON.stringify({ reference, agent }),
    });
};
const removeCarrier = async (id) => {
    return await client({
        method: 'DELETE',
        path: `/admin/api/jobs/${id}/carrier`,
    });
};
/**
 * declineAccessorials - makes a network request from car portal
 * @params {Object} params - includes sendEmail, array of Accessoirals, and resolutionType
 * @returns {Object} client
 */
const declineAccessorial = async (params) => {
    return await client({
        method: 'POST',
        path: 'api/accessorials/resolve-status',
        entity: JSON.stringify(params),
    });
};
const updateChangeException = async (shipment_id, params) => {
    return await client({
        method: 'POST',
        path: `/api/jobs/${shipment_id}/exception/change-request`,
        entity: JSON.stringify(params),
    });
};
const updateShipmentAdjustments = (id, type, adjustments) => {
    return client({
        method: 'PATCH',
        path: `/admin/api/jobs/${id}/adjustments`,
        entity: JSON.stringify({ type, adjustments }),
    });
};
function cloneShipment(shipment, options) {
    return client({
        method: 'POST',
        path: `/admin/api/v2/jobs/${shipment._id}/clone`,
        entity: JSON.stringify(Object.assign({}, options)),
    });
}
const addBulkYardStops = (offsiteYardStops) => {
    return client({
        method: 'POST',
        path: '/admin/api/v2/jobs/bulk/stops',
        entity: JSON.stringify(offsiteYardStops),
    });
};
export function getShipmentByOid(id) {
    return new Promise((resolve, reject) => {
        getShipment(id)
            .then((res) => {
            if (res.entity && res.entity.item) {
                resolve(res.entity.item);
            }
            resolve(null);
        })
            .catch((e) => {
            reject(e);
        });
    });
}
export function getStopAudits(id) {
    return new Promise((resolve, reject) => {
        getStopAuditEvents(id)
            .then((res) => {
            if (res.entity) {
                resolve(res.entity);
            }
            resolve(null);
        })
            .catch((e) => {
            reject(e);
        });
    });
}
export function uploadReferenceNumbers(file) {
    return new Promise((resolve, reject) => {
        request
            .post(`${API_HOST}/api/v2/documents/shipment-refs`)
            .set('Authorization', getBearerGrantTypeAuthHeaders())
            .attach('shipment_ref_csv', file)
            .end((err, res) => {
            if (err) {
                reject(err);
            }
            else {
                resolve(res);
            }
        });
    });
}
export function uploadBulkShipmentCancellation(file) {
    return new Promise((resolve, reject) => {
        request
            .post(`${API_HOST}/api/v2/documents/bulk-shipment-cancellation`)
            .set('Authorization', getBearerGrantTypeAuthHeaders())
            .attach('bulk_shipment_cancellation_csv', file)
            .end((err, res) => {
            if (err) {
                reject(err);
            }
            else {
                resolve(res);
            }
        });
    });
}
export function uploadBulkShipmentRerate(file, emails) {
    return new Promise((resolve, reject) => {
        request
            .post(`${API_HOST}/admin/api/v2/jobs/rerate/bulk`)
            .set('Authorization', getBearerGrantTypeAuthHeaders())
            .field('emails', emails)
            .attach('bulk_rerate_shipment_csv', file)
            .end((err, res) => {
            if (err) {
                reject(err);
            }
            else {
                resolve(res);
            }
        });
    });
}
function uploadShipmentDocument({ shipmentId, file, docType, signatory }) {
    request
        .post(`${API_HOST}/api/v2/jobs/${shipmentId}/upload`)
        .set('Authorization', getBearerGrantTypeAuthHeaders())
        .field('name', docType)
        .field('signatory', signatory)
        .attach('file', file)
        .end((err, res) => {
        if (err) {
            AdminServerActionCreators.uploadShipmentDocumentsFail();
        }
        const response = JSON.parse(res.body);
        if (response.success) {
            AdminServerActionCreators.uploadShipmentDocumentsSuccess({
                shipmentId: response.data.shipment_id,
                shipment: response.data,
            });
        }
        else {
            AdminServerActionCreators.uploadShipmentDocumentsFail();
        }
    });
}
function uploadStopDocument({ shipment, stop, docType, file, signatory }) {
    const shipmentId = shipment._id;
    const stopId = stop._id;
    request
        .post(`${API_HOST}/api/v2/jobs/${shipmentId}/stops/${stopId}/upload`)
        .set('Authorization', getBearerGrantTypeAuthHeaders())
        .field('name', docType)
        .field('job_id', shipmentId)
        .field('signatory', signatory || '')
        .attach('file', file)
        .end((err, res) => {
        if (err) {
            console.log(err);
            AdminServerActionCreators.uploadShipmentDocumentsFail();
            return;
        }
        if (res.success) {
            AdminServerActionCreators.uploadShipmentDocumentsSuccess({
                shipmentId: res.data.shipment_id,
                shipment: res.data,
            });
        }
        else {
            AdminServerActionCreators.uploadShipmentDocumentsFail();
        }
    });
}
function uploadStopDocuments(shipment, stop, files, signatory) {
    return new Promise((resolve, reject) => {
        const req = request.post(`${API_HOST}/api/1/stops/pod/upload`);
        const shipmentId = shipment.id;
        const stopId = stop._id;
        req
            .set('Authorization', getBearerGrantTypeAuthHeaders())
            .field('job_id', shipmentId)
            .field('stop_id', stopId)
            .field('signatory', signatory);
        files.forEach((file) => {
            req.attach('file', file.content);
        });
        req.end((err, res) => {
            const result = res.body;
            if (err) {
                return reject(new Error(err.message || i18next.t('ERROR_UPLOADING_DOCUMENTS')));
            }
            if (result.success) {
                return resolve(result);
            }
            return reject(new Error(result.message || i18next.t('ERROR_UPLOADING_DOCUMENTS')));
        });
    });
}
export function validatePdfFileAttachments(files) {
    return new Promise((resolve, reject) => {
        const req = request.post(`${API_HOST}/api/document/validatePdfs`);
        req.set('Authorization', getBearerGrantTypeAuthHeaders());
        files.forEach((file) => {
            req.attach('file', file);
        });
        req.end((err, res) => {
            if (err) {
                reject(res);
            }
            if (res.body.success) {
                resolve(res.body.result);
            }
            else {
                reject(res);
            }
        });
    });
}
// Carrier Portal Accessorial Document Uploader
function uploadAccessorialDocument(id, files, name, notes, message) {
    const req = request.post(`${API_HOST}/api/accessorials/${id}/upload`);
    req
        .set('Authorization', getBearerGrantTypeAuthHeaders())
        .field('name', name)
        .field('message', message)
        .field('notes', notes);
    files.forEach((file) => {
        req.attach('file', file);
    });
    req.end((err, response) => {
        if (err) {
            return AdminServerActionCreators.onUploadAccessorialDocFail(err);
        }
        AdminServerActionCreators.onUploadAccessorialDocSuccess(response.body.request);
    });
}
// Called from Shipment Details Document Upload Dropzone
function uploadFile(shipment, name, files, signatory, userRoles) {
    const req = request.post(`${API_HOST}/api/v2/jobs/${shipment._id}/upload`);
    req
        .set('Authorization', getBearerGrantTypeAuthHeaders())
        .field('name', name)
        .field('job_id', shipment._id)
        .field('signatory', signatory || '')
        .field('user_visibility', userRoles);
    // Add user type here
    files.forEach((file) => {
        req.attach('file', file);
    });
    req.end((err, response) => {
        shipment.timeline = response.body.data.timeline;
        AdminServerActionCreators.receiveShipmentUpdate(shipment);
    });
}
function uploadDocumentAndGetDocumentURI(files, job_id, stop_id, action) {
    const req = request.post(`${API_HOST}/api/1/stops/pod/upload`);
    req
        .set('Authorization', getBearerGrantTypeAuthHeaders())
        .field('job_id', job_id)
        .field('stop_id', stop_id);
    files.forEach((file) => {
        req.attach('file', file);
    });
    req.end((err, response) => {
        if (err || response.status !== 200) {
            AdminServerActionCreators.receiveDocumentURIFail({
                job_id,
                stop_id,
                action,
            });
        }
        else {
            AdminServerActionCreators.receiveDocumentURISuccess(Object.assign(Object.assign({}, response.body), { job_id,
                stop_id,
                action }));
        }
    });
}
function fetchQuote(id) {
    return client({
        method: 'GET',
        path: `/api/1/quotes/${id}`,
    });
}
const bulkTransitionShipmentsToArrived = (body) => {
    return client({
        method: 'POST',
        path: '/admin/api/v1/jobs/bulk/transition',
        entity: JSON.stringify(body),
    });
};
const bulkUpdateDates = (body) => {
    return client({
        method: 'POST',
        path: '/api/v2/jobs/bulk/dates',
        entity: JSON.stringify(body),
    });
};
const bulkUpdateNotes = (body) => {
    return client({
        method: 'POST',
        path: '/api/v2/jobs/bulk/notes',
        entity: JSON.stringify(body),
    });
};
const bulkUpdateSpecialInstructions = (body) => {
    return client({
        method: 'PATCH',
        path: '/admin/api/v2/jobs/bulk/instructions',
        entity: JSON.stringify(body),
    });
};
const bulkUpdateShipments = (body) => {
    return client({
        method: 'PATCH',
        path: '/api/v2/jobs/bulk/update',
        entity: JSON.stringify(body),
    });
};
const updateDeliveryOrderStatus = (jobId, body) => {
    return client({
        method: 'POST',
        path: `/api/jobs/${jobId}/delivery-order/update`,
        entity: JSON.stringify(body),
    });
};
const getDriverJobs = async (driver) => {
    const queryString = qs.stringify({
        driver,
        status: ['accepted', 'in_progress'],
    });
    return client({
        method: 'GET',
        path: `/api/v2/jobs?${queryString}`,
    });
};
const generateCarrier204 = async (job, event) => {
    return client({
        method: 'POST',
        path: `/admin/api/v1/jobs/204/carrier`,
        entity: JSON.stringify({ job, event }),
    });
};
const getShipmentsByShipmentID = async (referenceNumbers) => {
    return client({
        method: 'GET',
        path: `/api/v1/jobs/reference-search/adjustments?referenceNumbers=${encodeURIComponent(referenceNumbers.join(','))}`,
    });
};
export const sendFeesDuePaymentLink = async (jobId, recipients) => {
    return client({
        method: 'POST',
        path: `/admin/api/jobs/${jobId}/fees-due/email`,
        entity: JSON.stringify({ recipients }),
    });
};
const createBaseCostAdjustments = async (adjustments) => {
    return client({
        method: 'POST',
        path: '/admin/api/v3/jobs/adjustments/bulk',
        entity: JSON.stringify({ adjustments }),
    });
};
const createOutgateShipmentStops = async (jobId, data) => {
    return client({
        method: 'POST',
        path: `/api/v1/jobs/${jobId}/outgate`,
        entity: JSON.stringify(data),
    });
};
const splitShipment = async (jobId, data) => {
    return await client({
        method: 'POST',
        path: `/api/v2/jobs/${jobId}/split`,
        entity: JSON.stringify(data),
    });
};
const getShipmentsLedgers = async (jobIds, ledgerType) => {
    return await client({
        method: 'POST',
        path: `/api/v3/jobs/ledgers`,
        entity: JSON.stringify({ jobIds, ledgerType }),
    });
};
const deleteStopDocumentsV2 = (shipmentId, stop, documentIds) => {
    const stopId = stop._id;
    return client({
        method: 'POST',
        path: `${API_HOST}/api/1/stops/pod/remove`,
        entity: JSON.stringify({
            job_id: shipmentId,
            stop_id: stopId,
            document_ids: documentIds,
        }),
    });
};
export const getMissingReferenceNumbers = (job, stage) => {
    return client({
        method: 'POST',
        path: `${API_HOST}/api/v3/jobs/reference-numbers/status`,
        entity: JSON.stringify(Object.assign({ job }, (stage && { stage }))),
    });
};
export const bulkAddShipmentReferenceNumbers = (updates) => {
    return client({
        method: 'POST',
        path: `${API_HOST}/admin/api/v3/jobs/reference-numbers/bulk`,
        entity: JSON.stringify({ updates }),
    });
};
export const bulkAddTerminalHoldStatus = (updates) => {
    return client({
        method: 'POST',
        path: `${API_HOST}/admin/api/v2/jobs/bulk/hold_status`,
        entity: JSON.stringify(updates),
    });
};
const getMissingReferenceNumbersList = (job, stage) => {
    return client({
        method: 'POST',
        path: `${API_HOST}/api/v3/jobs/reference-numbers/status/missing-numbers`,
        entity: JSON.stringify(Object.assign({ job }, (stage && { stage }))),
    });
};
const getMissingReferenceNumbersAtBookingTime = (job) => {
    return client({
        method: 'POST',
        path: `${API_HOST}/api/v3/jobs/reference-numbers/status/booking`,
        entity: JSON.stringify({ job }),
    });
};
export const updateSealNumberOnStopReferenceNumbers = async (jobId, stopId, sealNumber) => {
    var _a;
    const sealNumberRefNumber = {
        name: 'seal_number',
        stop_id: stopId,
        value: sealNumber,
        optimized: (_a = sealNumber === null || sealNumber === void 0 ? void 0 : sealNumber.toUpperCase()) === null || _a === void 0 ? void 0 : _a.trim(),
    };
    return await axios({
        method: 'put',
        url: `${API_HOST}/api/v2/jobs/${jobId}/stops/${stopId}/seal`,
        data: [sealNumberRefNumber],
        headers: {
            'Content-Type': 'application/json',
            Authorization: getBearerGrantTypeAuthHeaders(),
        },
    });
};
export const updateSealNumberOnStopReferenceNumbersBulk = async (payload) => {
    return await axios({
        method: 'put',
        url: `${API_HOST}/api/v2/jobs/seal/bulk`,
        data: payload,
        headers: {
            'Content-Type': 'application/json',
            Authorization: getBearerGrantTypeAuthHeaders(),
        },
    });
};
export const updatePreArrivalShipmentStatus = async (payload = {}) => {
    return await axios({
        method: 'patch',
        url: `${API_HOST}/admin/api/orders/set-pre-arrival-status`,
        data: payload,
        headers: {
            'Content-Type': 'application/json',
            Authorization: getBearerGrantTypeAuthHeaders(),
        },
    });
};
const API = {
    async fetchQuote(id) {
        return await fetchQuote(id).then((response) => {
            return response.entity.quote;
        }, (error) => {
            throw error;
        });
    },
    uploadAccessorialDocument(id, files, name, notes, message) {
        uploadAccessorialDocument(id, files, name, notes, message);
    },
    updateCarrier(carrier, shipments) {
        return updateCarrier(carrier, shipments)
            .then((response) => {
            AdminServerActionCreators.receiveUpdateCarrierSuccess(response.entity.jobs);
        })
            .catch((response) => {
            AdminServerActionCreators.receiveUpdateCarrierFail(response);
            throw response;
        });
    },
    updateShipper(shipper, shipments) {
        updateShipper(shipper, shipments).then((response) => {
            AdminServerActionCreators.receiveUpdateShipperSuccess(response.entity.jobs);
        }, (response) => {
            console.log('Failed updating shipper', response);
        });
    },
    updateConsignee(consignee, shipments) {
        updateConsignee(consignee, shipments).then((response) => {
            AdminServerActionCreators.receiveUpdateConsigneeSuccess(response.entity.jobs);
        }, (response) => {
            AdminServerActionCreators.receiveUpdateConsigneeFail(response);
        });
    },
    createOffer(offer) {
        createOffer(offer).then((response) => {
            // putting this here for now, since there's no immediately obvious place for it
            ShipmentsActionCreators.clearDocuments();
            AdminServerActionCreators.receiveCreatedOffer(response.entity.offer);
        }, (response) => {
            /* {"message":"tariff for given shipment.numberOfPallets 0 was not found"} */
            console.log(response);
            AdminServerActionCreators.createOfferFail(response.entity.message);
        });
    },
    createOrderShipment(offer) {
        createOrderShipment(offer).then((response) => AdminServerActionCreators.createOrderShipmentSuccess(response.entity.offers[0]), (response) => AdminServerActionCreators.createOrderShipmentFail(response.entity.message));
    },
    async bookV2(offer) {
        return await createOrderShipment(offer).then((response) => {
            return response.entity.offers[0];
        }, (response) => {
            showToast(i18next.t('BOOKING_FAILED'), i18next.t('BOOKING_FAILED_WITH_ERR', {
                message: response.entity.message,
            }), 'error');
            throw new Error(response.entity.message);
        });
    },
    deleteQuote(quoteId) {
        deleteQuote(quoteId).then((response) => AdminServerActionCreators.deleteQuoteSuccess(response), (response) => AdminServerActionCreators.deleteQuoteFail(response));
    },
    createQuote(quote) {
        createQuote(quote).then((response) => AdminServerActionCreators.createQuoteSuccess(response.entity.quote), (response) => AdminServerActionCreators.createQuoteFail(response.entity.message));
    },
    updateQuote(quote) {
        updateQuote(quote).then((response) => AdminServerActionCreators.updateQuoteSuccess(response.entity.quote), (response) => AdminServerActionCreators.updateQuoteFail(response.entity.message));
    },
    uploadBookingDocument(key, type, file) {
        file.bucketType = 'shipmentdata';
        DocumentsWebAPIUtils.uploadFilePublic(key, type, file);
    },
    getDistance(origin, destination) {
        getDistance(origin, destination).then((response) => {
            AdminServerActionCreators.receiveShipmentDistanceSuccess(response.entity);
        }, (response) => {
            console.error('failure!', response);
        });
    },
    getDistanceV3(origin, destination, shipperId) {
        getDistanceV3(origin, destination, shipperId).then((response) => {
            AdminServerActionCreators.receiveShipmentDistanceSuccess(response.entity);
        }, (response) => {
            console.error('failure!', response);
        });
    },
    async getDistanceV2(offer) {
        return await getDistanceV2(offer).then((response) => {
            return response.entity.distance;
        }, (response) => {
            throw new Error(response.entity.message);
        });
    },
    getShipmentsForExportDocs(query, success, fail) {
        getShipmentsForExportDocs(query).then(success, fail);
    },
    getShipmentsV2(query, success, fail) {
        getShipments(query).then(success, fail);
    },
    getShipments(query) {
        getShipmentsLegacy(query).then(getShipmentSuccess, getShipmentFailure);
    },
    getShipmentsByQuery(query, success, fail) {
        getShipmentsLegacy(query).then(success, fail);
    },
    getShipmentsByReference(query, success, fail) {
        getShipmentsByReferenceNumber(query).then(success, fail);
    },
    getShipmentsForCsv(query, columns, callback) {
        getShipmentsForCsv(query, columns).then((response) => {
            fileDownload(response.entity, 'shipments.csv');
            callback();
        }, (response) => {
            console.log('Export Result', response);
        });
    },
    getShipmentAuditEvents(id) {
        getShipmentAuditEvents(id).then((response) => {
            AdminServerActionCreators.receiveShipmentAuditSuccess(response.entity);
        }, (response) => {
            console.log('Failed to get event audits', response);
        });
    },
    getShipmentV2(id, options = {}) {
        getShipment(id, options).then((response) => {
            response.entity.job = transformInboundShipments([
                response.entity.item,
            ])[0];
            AdminServerActionCreators.receiveShipmentSuccess(response.entity);
        }, (response) => {
            console.error('failure!', response);
        });
    },
    getShipment(id, isAdmin) {
        getShipmentLegacy(id, isAdmin).then((response) => {
            response.entity.job = transformInboundShipments([
                response.entity.job,
            ])[0];
            AdminServerActionCreators.receiveShipmentSuccess(response.entity);
        }, (response) => {
            console.error('failure!', response);
        });
    },
    closeShipment(shipment, reason) {
        closeShipment(shipment, reason).then((response) => {
            AdminServerActionCreators.receiveShipmentCloseSuccess(response.entity.job);
            AdminServerActionCreators.receiveShipmentUpdate(response.entity.job);
        }, () => {
            AdminServerActionCreators.receiveShipmentCloseFailure(shipment);
        });
    },
    async generateRateConfirmation(jobId, emails, send) {
        return await generateRateConfirmation(jobId, emails, send).then((response) => {
            if (!send) {
                AdminServerActionCreators.sendRateConfirmationSuccess(response.entity);
            }
            else {
                AdminServerActionCreators.sendRateConfirmationSentSuccess(response.entity);
            }
            return response.entity;
        }, (error) => {
            throw error;
        });
    },
    async sendRateConfirmation(jobId, emails, send) {
        return await sendRateConfirmation(jobId, emails, send).then((response) => {
            if (!send) {
                AdminServerActionCreators.sendRateConfirmationSuccess(response.entity);
            }
            else {
                AdminServerActionCreators.sendRateConfirmationSentSuccess(response.entity);
            }
            return response;
        }, (error) => {
            throw error;
        });
    },
    cancelShipment(shipment, reason, comment) {
        cancelShipment(shipment, reason, comment).then((response) => {
            AdminServerActionCreators.receiveShipmentSuccess(response.entity);
        }, () => {
            AdminServerActionCreators.receiveShipmentCanceledFailure(shipment);
        });
    },
    cancelShipmentForUser(shipment, user, reason) {
        if (user._type === 'Carrier') {
            setCancellationReason(shipment, user, reason)
                .then(() => exposeOffer(shipment))
                .then(() => {
                AdminServerActionCreators.receiveShipmentCanceledSuccess(shipment);
            }, () => {
                AdminServerActionCreators.receiveShipmentCanceledFailure(shipment);
            });
        }
        else if (user._type === 'Shipper') {
            cancelShipmentForShipper(shipment, reason).then((response) => {
                if (response.entity.job.current)
                    shipment.current = false;
                shipment.canceled = true;
                shipment.timeline = response.entity.job.timeline;
                AdminServerActionCreators.receiveShipmentCanceledSuccess(shipment);
            }, () => {
                AdminServerActionCreators.receiveShipmentCanceledFailure(shipment);
            });
        }
    },
    bulkAssignDriver(driver, shipments) {
        bulkAssignDriver(driver, shipments).then((response) => {
            AdminServerActionCreators.setDriverSuccess(response);
        }, (response) => {
            AdminServerActionCreators.setDriverFail(response.entity.error);
        });
    },
    assignDriver(shipment, driver) {
        assignDriver(shipment, driver).then((response) => {
            AdminServerActionCreators.receiveShipmentSuccess(response.entity);
            AdminServerActionCreators.setDriverSuccess();
        }, (response) => {
            AdminServerActionCreators.setDriverFail(response.entity.error);
        });
    },
    asyncAssignDriver(shipment, driver) {
        return assignDriver(shipment, driver);
    },
    updateShipmentStopScheduling(id, stop, data) {
        updateShipmentStopScheduling(id, stop, data).then((response) => {
            AdminServerActionCreators.receiveShipmentSuccess(response.entity);
        }, (response) => {
            console.error('response fail', response);
        });
    },
    async updateShipmentStopSchedulingResponse(id, stop, data) {
        return await updateShipmentStopScheduling(id, stop, data).then((response) => {
            return response;
        });
    },
    updateMassShipmentStopScheduling(action, shipments) {
        updateMassShipmentStopScheduling(shipments).then((response) => AdminServerActionCreators.receiveMassShipmentsSuccess(action, response.entity), (response) => AdminServerActionCreators.receiveMassShipmentsSuccess(action, response.entity));
    },
    updateTags(shipment, tags) {
        updateShipmentHandler(shipment, { tags });
    },
    updateTrackingId(shipment, trackingId) {
        updateShipmentHandler(shipment, { tracking_id: trackingId });
    },
    updateMoNumber(shipment, moNumber) {
        updateShipmentHandler(shipment, { mo_number: moNumber });
    },
    updateHAWB(shipment, hawb) {
        updateShipmentHandler(shipment, { house_bill_number: hawb });
    },
    updateShipmentType(shipment, shipmentType) {
        updateShipmentHandler(shipment, { shipment_type: shipmentType });
    },
    updatePODValid(shipment, is_pod_valid) {
        updateShipmentHandler(shipment, { is_pod_valid });
    },
    updateEstimatedArrival(shipment, estimated_arrival) {
        updateShipmentHandler(shipment, { estimated_arrival });
    },
    updateArrivalDate(shipment, arrival_date) {
        updateShipmentHandler(shipment, { arrival_date });
    },
    updateAvailableDate(shipment, available_date) {
        updateShipmentHandler(shipment, { available_date });
    },
    updateDischargeDate(shipment, discharge_date) {
        updateShipmentHandler(shipment, { discharge_date });
    },
    updateLastFreeDate(shipment, last_free_date) {
        updateShipmentHandler(shipment, { last_free_date });
    },
    updateYardLastFreeDate(shipment, yard_last_free_date) {
        updateShipmentHandler(shipment, { yard_last_free_date });
    },
    updateEmptyReturnedDate(shipment, empty_returned_date) {
        updateShipmentHandler(shipment, { empty_returned_date });
    },
    updateEmptyReadyForPickupDate(shipment, empty_ready_for_pickup) {
        updateShipmentHandler(shipment, { empty_ready_for_pickup });
    },
    updatePerDiemDate(shipment, per_diem_lfd) {
        updateShipmentHandler(shipment, { per_diem_lfd });
    },
    updateLastCutDate(shipment, last_cut_date) {
        updateShipmentHandler(shipment, { last_cut_date });
    },
    updateDocumentCutoffDate(shipment, document_cutoff_date) {
        updateShipmentHandler(shipment, { document_cutoff_date });
    },
    updateEarliestReturnDate(shipment, earliest_return_date) {
        updateShipmentHandler(shipment, { earliest_return_date });
    },
    updateEarliestEmptyDate(shipment, earliest_empty_date) {
        updateShipmentHandler(shipment, { earliest_empty_date });
    },
    updateImportantDates(shipment, event, value) {
        const update = {};
        update[event] = value;
        updateShipmentHandler(shipment, update);
    },
    updateShipmentActionDates(shipment, event, value) {
        const update = {};
        update[event] = value;
        updateShipmentHandler(shipment, update);
    },
    updateOutgatedDate(shipment, outgated_date) {
        updateShipmentHandler(shipment, { outgated_date });
    },
    updateYardAvailableDate(shipment, yard_available_date) {
        updateShipmentHandler(shipment, { yard_available_date });
    },
    updateRailEvent(shipment, event, value) {
        const update = {};
        update[event] = value;
        updateShipmentHandler(shipment, update);
    },
    getStopAudits(id) {
        return getStopAudits(id);
    },
    async updateStackPosition(shipment, stackPosition) {
        try {
            const payload = {
                stack_position: stackPosition,
            };
            const res = await client({
                method: 'POST',
                path: `/admin/api/v3/jobs/${shipment._id}/stack-position`,
                entity: JSON.stringify(payload),
            });
            if (res.entity.success) {
                const updatedShipment = Object.assign({}, shipment, res.entity.data);
                AdminServerActionCreators.receiveShipmentUpdate(updatedShipment);
            }
            else {
                AdminServerActionCreators.receiveShipmentUpdateError();
            }
        }
        catch (e) {
            console.error(e);
            AdminServerActionCreators.receiveShipmentUpdateError();
        }
    },
    updateEquipmentType(shipment, equipment_type) {
        updateShipmentHandler(shipment, { equipment_type });
    },
    updateExceptionExemptFlag(shipment, exception_exempt) {
        updateShipmentHandler(shipment, { exception_exempt });
    },
    updateMGLoadId(shipment, mgLoadId) {
        const update = { mg_load_id: mgLoadId, edi_version: 2 };
        if (mgLoadId === '')
            update.edi_version = 0;
        updateShipmentHandler(shipment, update);
    },
    updateReferenceNumbers(shipment, rawReferenceNumbers, updatedRefEvents) {
        const reference_numbers = rawReferenceNumbers.map((r) => {
            const filteredName = (r.name || '').trim();
            const filteredValue = (r.value || '').trim();
            const optimized = filteredValue.toUpperCase();
            const refNum = {
                name: filteredName,
                value: filteredValue,
                optimized,
            };
            refNum.editable = !!r.editable;
            // Don't leave out the stop_id for stop-specific reference numbers.
            if (r.stop_id) {
                refNum.stop_id = r.stop_id;
            }
            return refNum;
        });
        const updates = {
            reference_numbers,
            updatedRefEvents,
        };
        const addAttribute = (name, updates) => {
            const refnum = reference_numbers.find((r) => r.name === name);
            if (refnum) {
                updates[refnum.name] = refnum.value;
            }
        };
        addAttribute('mo_number', updates);
        addAttribute('mg_load_id', updates);
        addAttribute('house_bill_number', updates);
        addAttribute('tracking_id', updates);
        updateShipmentHandler(shipment, updates);
    },
    updateShipmentStops(shipment, stops) {
        updateShipmentHandler(shipment, stops);
    },
    updateShipmentStopLocation(shipment, stop, updates) {
        updateShipmentStopLocation(shipment, stop, updates).then((response) => {
            AdminServerActionCreators.receiveShipmentSuccess(response.entity);
        }, (response) => {
            console.error('response fail', response);
        });
    },
    updateShipmentStopReferenceNumbers(shipment, stop, updates) {
        updateShipmentStopReferenceNumbers(shipment, stop, updates).then((response) => {
            AdminServerActionCreators.receiveShipmentSuccess(response.entity);
        }, (response) => {
            console.error('response fail', response);
        });
    },
    updateStopSequences(shipment, stopSequences) {
        updateStopSequences(shipment, stopSequences).then((response) => AdminServerActionCreators.receiveShipmentSuccess(response.entity), (response) => console.log('response fail: ', response));
    },
    updateShipmentStopAttempt(shipment, stop, data) {
        updateShipmentStopAttempt(shipment, stop, data).then((response) => {
            AdminServerActionCreators.receiveShipmentSuccess(response.entity);
        }, (response) => {
            console.error('response fail', response);
        });
    },
    updateShipmentStop(shipment, stop, updates) {
        updateShipmentStop(shipment, stop, updates).then((response) => {
            AdminServerActionCreators.receiveShipmentSuccess(response.entity);
        }, (response) => {
            console.error('response fail', response);
        });
    },
    updateShipmentStopEquipment(shipment, stop, updates, isCarrier = false) {
        updateShipmentStopEquipment(shipment, stop, updates, isCarrier).then((response) => {
            const { entity: { job }, } = response;
            handleStopEquipmentUpdateSuccess({ job });
        }, (response) => {
            handleStopEquipmentUpdateFail(response);
        });
    },
    /*
    updateOnHold(shipment, on_hold, on_hold_description) {
      updateShipmentHandler(shipment, {
        on_hold,
        on_hold_description,
      });
    },
    */
    updateOnHold(shipment, on_hold, on_hold_description, on_hold_reason) {
        updateOnHold(shipment, on_hold, on_hold_description, on_hold_reason).then(() => {
            const updatedShipment = assign(shipment, {
                on_hold,
                on_hold_description,
                on_hold_reason,
            });
            AdminServerActionCreators.receiveShipmentUpdate(updatedShipment);
        }, (response) => {
            AdminServerActionCreators.receiveShipmentUpdateError(response);
        });
    },
    updateExposed(shipment, exposed) {
        updateExposed(shipment, exposed).then(() => {
            const updatedShipment = assign(shipment, { exposed });
            AdminServerActionCreators.receiveShipmentUpdate(updatedShipment);
        }, (response) => {
            AdminServerActionCreators.receiveShipmentUpdateError(response);
        });
    },
    updateShipmentStopLoads(shipment, stop, updates) {
        updateShipmentStopLoads(shipment, stop, updates).then((response) => {
            AdminServerActionCreators.receiveShipmentSuccess(response.entity);
        }, (response) => {
            console.error('response fail', response);
        });
    },
    completeStop(shipment, stop, file, meta) {
        completeStop(shipment, stop, file, meta).then((response) => {
            AdminServerActionCreators.receiveShipmentStopCompleteSuccess(response.entity);
        }, (response) => {
            AdminServerActionCreators.receiveShipmentStopCompleteFailure(response.entity);
        });
    },
    completeMassStops(action, shipments) {
        completeMassStops(shipments).then((response) => AdminServerActionCreators.receiveMassShipmentsSuccess(action, response.entity), (response) => AdminServerActionCreators.receiveMassShipmentsSuccess(action, response.entity));
    },
    arrivedMassStops(action, shipments) {
        arrivedMassStops(shipments).then((response) => AdminServerActionCreators.receiveMassShipmentsSuccess(action, response.entity), (response) => AdminServerActionCreators.receiveMassShipmentsSuccess(action, response.entity));
    },
    transitionStop(shipment, stop, workflow, meta) {
        transitionStop(shipment, stop, workflow, meta).then((response) => {
            AdminServerActionCreators.receiveShipmentStopCompleteSuccess(response.entity);
        }, (response) => {
            AdminServerActionCreators.receiveShipmentStopCompleteFailure(response.entity);
        });
    },
    updateAdminNotes(shipment, notes) {
        updateShipmentHandler(shipment, { admin_notes: notes });
    },
    updatePODStatus(shipmentId, status) {
        getShipment(shipmentId).then((response) => {
            const shipment = transformInboundShipments([response.entity.item])[0];
            updateShipmentHandler(shipment, { pod_status: status });
        });
    },
    updateAdminNotesById(id, notes) {
        getShipment(id).then((response) => {
            response.entity.job = transformInboundShipments([
                response.entity.item,
            ])[0];
            this.updateAdminNotes(response.entity.job, notes);
        }, (response) => {
            console.error('failure!', response);
            const message = response.entity && response.entity.error
                ? response.entity.error.message
                : 'Unknown error';
            showToast(i18next.t('FAILED_TO_UPDATE_SHIPMENTS'), message, 'error');
        });
    },
    updateShipperNotes(shipment, notes) {
        updateShipmentHandler(shipment, { notes });
    },
    uploadDocument(shipment, name, file, signatory, userRole) {
        uploadFile(shipment, name, file, signatory, userRole);
    },
    uploadDocumentAndGetDocumentURI(file, job_id, stop_id, action) {
        uploadDocumentAndGetDocumentURI(file, job_id, stop_id, action);
    },
    uploadShipmentDocument({ shipmentId, file, docType, signatory }) {
        uploadShipmentDocument({ shipmentId, file, docType, signatory });
    },
    uploadStopDocument(shipment, stop, docType, file, signatory) {
        uploadStopDocument({ shipment, stop, docType, file, signatory });
    },
    updatePrice(shipment) {
        getPrice(shipment).then((response) => {
            AdminServerActionCreators.receivePrice(response.entity.price);
        }, (response) => {
            AdminServerActionCreators.getPriceFail(response.entity);
        });
    },
    rerateShipmentCosts(shipment, costsToBeRerated) {
        rerateCosts(shipment, costsToBeRerated).then((response) => {
            AdminServerActionCreators.rerateCostsSuccess(response.entity);
        }, (response) => {
            AdminServerActionCreators.rerateCostsFailure(response.entity);
        });
    },
    async getPrice(shipment) {
        return await getPrice(shipment).then((response) => {
            return response.entity.price;
        }, (response) => {
            throw new Error(response.entity.err);
        });
    },
    processBol(jobId, emails, send) {
        processBol(jobId, emails, send).then((response) => {
            if (!send) {
                AdminServerActionCreators.processBolSuccess(response.entity);
            }
            else {
                AdminServerActionCreators.processBolSentSuccess(response.entity);
            }
        }, (response) => {
            AdminServerActionCreators.processBolFail(response.entity);
        });
    },
    notifyCarrierAccessorials(jobId, emails) {
        notifyCarrierAccessorials(jobId, emails).then((response) => {
            AdminServerActionCreators.carrierReceviedEmail(response.entity);
        }, () => {
            console.error('Failed to send decline customer accessorial');
        });
    },
    sendDeliveryOrder(jobId, emails) {
        sendDeliveryOrder(jobId, emails).then((response) => {
            AdminServerActionCreators.receiveSendDeliveryOrderSuccess(response.entity);
        }, () => {
            console.error('Failed to send delivery order');
        });
    },
    addComment(id, comment) {
        return addComment(id, comment);
    },
    addAccessorial: function (shipment, accessorial, meta) {
        addAccessorial(shipment, accessorial, meta).then(function addAccessorialSuccess(response) {
            shipment.receivables = response.entity.job.receivables;
            shipment.payables = response.entity.job.payables;
            shipment.shipper_accessorials =
                response.entity.job.shipper_accessorials;
            AdminServerActionCreators.onAddAccessorialSuccess();
            AdminServerActionCreators.receiveShipmentUpdate(shipment);
        }, (response) => {
            const getErrMessage = (message) => {
                switch (message) {
                    case 'UNAUTHORIZED':
                        return i18next.t('ADD_ACCESSORIAL_ERROR_UNAUTHORIZED');
                    case 'ACCESSORIAL_EXISTS':
                        return i18next.t('ADD_ACCESSORIAL_ERROR_ACCESSORIAL_EXISTS');
                    default:
                        return i18next.t('ADD_ACCESSORIAL_ERROR_DEFAULT');
                }
            };
            showToast(i18next.t('ADD_ACCESSORIAL_ERROR'), getErrMessage(response.entity.error), 'error');
            return response.entity;
        });
    },
    removeAccessorial: function (shipment, accessorial) {
        removeAccessorial(shipment, accessorial).then(function removeAccessorialSuccess(response) {
            shipment.receivables = response.entity.job.receivables;
            shipment.payables = response.entity.job.payables;
            shipment.shipper_accessorials =
                response.entity.job.shipper_accessorials;
            AdminServerActionCreators.receiveShipmentUpdate(shipment);
        }, (response) => {
            const getErrMessage = (message) => {
                switch (message) {
                    case 'UNAUTHORIZED':
                        return i18next.t('ACCESSORIAL_REMOVAL_FAILED_UNAUTHORIZED');
                    default:
                        return i18next.t('ACCESSORIAL_REMOVAL_FAILED_DEFAULT');
                }
            };
            showToast(i18next.t('ACCESSORIAL_REMOVAL_FAILED'), getErrMessage(response.entity.error), 'error');
            return response.entity;
        });
    },
    bulkUpdateCarrierCosts(updates) {
        bulkUpdateCarrierCosts(updates).then((res) => AdminServerActionCreators.onBulkUpdateCarrierCostsSuccess(res.entity), (res) => AdminServerActionCreators.onBulkUpdateCarrierCostsFail(res));
    },
    addStopAccessorial: function (shipment, stop, accessorial, meta) {
        addStopAccessorial(shipment, stop, accessorial, meta).then(function addAccessorialSuccess(response) {
            shipment.receivables = response.entity.job.receivables;
            shipment.payables = response.entity.job.payables;
            shipment.shipper_accessorials =
                response.entity.job.shipper_accessorials;
            AdminServerActionCreators.onAddAccessorialSuccess();
            AdminServerActionCreators.receiveShipmentUpdate(shipment);
        }, (response) => {
            const message = response.entity && response.entity.error
                ? response.entity.error.message
                : i18next.t('UNKNOWN_ERROR');
            showToast(i18next.t('FAILED_TO_ADD_STOP_ACCESSORIAL'), message, 'error');
        });
    },
    removeStopAccessorial: function (shipment, stop, accessorial) {
        removeStopAccessorial(shipment, stop, accessorial).then(function removeAccessorialSuccess(response) {
            shipment.receivables = response.entity.job.receivables;
            shipment.payables = response.entity.job.payables;
            shipment.shipper_accessorials =
                response.entity.job.shipper_accessorials;
            AdminServerActionCreators.receiveShipmentUpdate(shipment);
        });
    },
    updateVendorPayable: async function (vendorPayableToAdjust) {
        return await updateVendorPayable(vendorPayableToAdjust);
    },
    addAdjustment: function (shipment, ledger, accessorial) {
        addAdjustment(shipment, ledger, accessorial).then(function addAdjustmentSuccess(response) {
            shipment[ledger] = response.entity.job[ledger];
            AdminServerActionCreators.receiveShipmentUpdate(shipment);
        }, (response) => {
            const getErrMessage = (message) => {
                switch (message) {
                    case 'UNAUTHORIZED':
                        return i18next.t('ADJUSTMENT_ADDITION_FAILED_UNAUTHORIZED');
                    default:
                        return i18next.t('ADJUSTMENT_ADDITION_FAILED_DEFAULT');
                }
            };
            showToast(i18next.t('ADJUSTMENT_ADDITION_FAILED'), getErrMessage(response.entity.error), 'error');
            return response.entity;
        });
    },
    async getAccountAccessRequestCount(userId) {
        try {
            const response = await getAccountAccessRequestCount(userId).catch((e) => {
                throw e;
            });
            return response;
        }
        catch (e) {
            const { entity: { error }, } = e;
            console.log(error);
        }
    },
    async setAccountAccessRequestApprove(requestId, grantorId, granteeUserAccountId, grantorEmail, grantData) {
        try {
            const response = await setAccountAccessRequestApprove(requestId, grantorId, granteeUserAccountId, grantorEmail, grantData).catch((e) => {
                throw e;
            });
            showToast('Account Access approved successfully', 'Approved successfully');
            return response;
        }
        catch (e) {
            const { entity: { error }, } = e;
            showToast('Failed to approve Account Access', `Approving the request failed with ${error}!`, 'error');
            return e;
        }
    },
    async setAccountAccessRequestDecline(requestId, grantorId, granteeUserAccountId, grantorEmail, grantData) {
        try {
            const response = await setAccountAccessRequestDecline(requestId, grantorId, granteeUserAccountId, grantorEmail, grantData).catch((e) => {
                throw e;
            });
            showToast('Account Access declined successfully', 'Declined successfully');
            return response;
        }
        catch (e) {
            const { entity: { error }, } = e;
            showToast('Failed to decline Account Access', `Declining the request failed with ${error}!`, 'error');
            return e;
        }
    },
    async addBaseCost(shipment, ledgerType, ledger) {
        try {
            const response = await addBaseCost(shipment, ledgerType, ledger).catch((e) => {
                throw e;
            });
            showToast(i18next.t('ADD_BASE_COST_SUCCESS'), i18next.t('ADD_BASE_COST_SUCCESS'));
            return response.entity;
        }
        catch (e) {
            const { entity: { error }, } = e;
            console.log(e);
            showToast(i18next.t('ADD_BASE_COST_FAILED'), error, 'error');
            return e;
        }
    },
    transitionTo(shipment, node, meta) {
        transitionTo(shipment, node, meta).then((response) => {
            response.entity.job = transformInboundShipments([
                response.entity.job,
            ])[0];
            AdminServerActionCreators.receiveShipmentSuccess(response.entity);
            AdminServerActionCreators.transitionShipmentSuccess(shipment);
        }, (error) => {
            AdminServerActionCreators.transitionShipmentFail(error);
        });
    },
    cloneShipment(shipment, options) {
        cloneShipment(shipment, options).then((response) => {
            response.entity.job = transformInboundShipments([
                response.entity.job,
            ])[0];
            AdminServerActionCreators.receiveShipmentSuccess(response.entity);
            AdminServerActionCreators.receiveShipmentCloneSuccess(response.entity);
        }, () => {
            console.error('Failed to transition shipment');
        });
    },
    shareShipment(jobId, payload) {
        shareShipment(jobId, payload).then((response) => {
            AdminServerActionCreators.shareShipmentSuccess();
            AdminServerActionCreators.receiveShareShipmentSuccess(response.entity);
        }, (errorResponse) => {
            if (errorResponse.entity) {
                AdminServerActionCreators.shareShipmentFail(errorResponse.entity);
            }
            else {
                AdminServerActionCreators.shareShipmentFail();
            }
        });
    },
    deleteDocument(shipment, id) {
        const documents = shipment.documents.map((doc) => {
            if (doc._id === id) {
                doc.show = false;
            }
            return doc;
        });
        updateShipmentHandler(shipment, { documents });
    },
    deleteStopDocument(shipment, stop, id) {
        const documents = stop.documents.map((doc) => {
            if (doc._id === id) {
                doc.show = false;
            }
            return doc;
        });
        updateShipmentStop(shipment, stop, { documents }).then((response) => {
            AdminServerActionCreators.receiveShipmentSuccess(response.entity);
        }, (response) => {
            console.error('response fail', response);
        });
    },
    cancelStop(job, stop) {
        cancelStop(job, stop).then((response) => {
            AdminServerActionCreators.receiveShipmentSuccess(response.entity);
        }, (response) => {
            console.error('Failed to create stop: ', response);
        });
    },
    copyStop(job, stop) {
        copyStop(job, stop).then((response) => {
            AdminServerActionCreators.receiveShipmentSuccess(response.entity);
        }, (response) => {
            console.error('Failed to create stop: ', response);
        });
    },
    createStop(jobId, payload) {
        createStop(jobId, payload).then((response) => {
            response.entity.job = transformInboundShipments([
                response.entity.job,
            ])[0];
            AdminServerActionCreators.receiveShipmentSuccess(response.entity);
        }, (response) => {
            console.error('Failed to create stop: ', response);
        });
    },
    addYardStop(offsiteYardStops) {
        return addBulkYardStops(offsiteYardStops).then((response) => {
            showToast(i18next.t('YARD_STOP_WAS_ADDED_SUCCESSFULLY'), i18next.t('YARD_STOP_WAS_ADDED_SUCCESSFULLY'), 'success');
            return response.entity;
        }, (response) => {
            showToast(i18next.t('YARD_STOP_WAS_NOT_ADDED'), i18next.t('YARD_STOP_WAS_NOT_ADDED'), 'error');
            console.error('Failed to create stop: ', response);
            return response.entity;
        });
    },
    addBulkYardStops(offsiteYardStops) {
        return addBulkYardStops(offsiteYardStops).then((response) => {
            showToast(i18next.t('YARDS_WERE_ADDED_SUCCESSFULLY'), i18next.t('YARDS_WERE_ADDED_SUCCESSFULLY'), 'success');
            return response;
        }, (response) => {
            showToast(i18next.t('YARDS_WERE_NOT_ADDED'), i18next.t('YARDS_WERE_NOT_ADDED'), 'error');
            console.error('Failed to bulk create stop: ', response);
            return response;
        });
    },
    async updateShipmentAdjustments(job, type, adjustments) {
        return updateShipmentAdjustments(job._id, type, adjustments).then((response) => {
            showToast(i18next.t('ADJUSTMENT_UPDATED_SUCCESSFULLY'), i18next.t('ADJUSTMENT_UPDATED_SUCCESSFULLY'), 'success');
            return response.entity;
        }, (response) => {
            const getErrMessage = (message) => {
                switch (message) {
                    case 'UNKNOWN_TYPE':
                        return i18next.t('ADJUSTMENT_UPDATE_FAILED_UNKNOWN_TYPE');
                    case 'UNKNOWN_ADJUSTMENT':
                        return i18next.t('ADJUSTMENT_UPDATE_FAILED_UNKNOWN_ADJUSTMENT');
                    case 'PROCESSED_ADJUSTMENT':
                        return i18next.t('ADJUSTMENT_UPDATE_FAILED_PROCESSED_ADJUSTMENT');
                    default:
                        return i18next.t('ADJUSTMENT_UPDATE_FAILED_DEFAULT');
                }
            };
            showToast(i18next.t('ADJUSTMENT_UPDATE_FAILED_DEFAULT'), getErrMessage(response.entity.error), 'error');
            return response.entity;
        });
    },
    updateAdjustments(job, adjustments) {
        updateShipment(job, adjustments).then((response) => AdminServerActionCreators.updateShipmentAdjustmentsSuccess(response.entity), (response) => console.error('Failed to update adjustments: ', response));
    },
    async updateChangeException(_id, params) {
        const result = await updateChangeException(_id, params).catch((result) => {
            showToast('Failed', `Error submiting Change Request-${result.error}`, `Error submiting Change Request-${result.error}`);
            return null;
        });
        if (result) {
            return result.entity.success;
        }
        return null;
    },
    async declineAccessorial(params) {
        const getErrorMsg = (slug) => {
            switch (slug) {
                case 'UNABLE_TO_DECLINE_ACCESSORIAL_REQUEST':
                    return i18next.t('ACCESSORIAL_DECLINED_ERROR_UNABLE_TO_DECLINE_ACCESSORIAL_REQUEST');
                case 'CARRIER_NOT_ASSIGNED':
                    return i18next.t('ACCESSORIAL_DECLINED_ERROR_CARRIER_NOT_ASSIGNED');
                case 'CARRIER_HAS_NO_VALID_CONTACTS':
                    return i18next.t('ACCESSORIAL_DECLINED_ERROR_CARRIER_HAS_NO_VALID_CONTACTS');
                case 'INVALID_RESOLUTION_TYPE':
                    return i18next.t('ACCESSORIAL_DECLINED_ERROR_INVALID_RESOLUTION_TYPE');
                default:
                    return i18next.t('ACCESSORIAL_DECLINED_ERROR_DEFAULT');
            }
        };
        const result = await declineAccessorial(params).catch((result) => {
            showToast(i18next.t('ACCESSORIAL_DECLINE_FAILED'), getErrorMsg(result.entity.error), 'error');
            return null;
        });
        if (result) {
            showToast(i18next.t('ACCESSORIAL_DECLINED'), i18next.t('ACCESSORIAL_DECLINE_SUCCESS'));
            return result;
        }
        return null;
    },
    async getTrackingShipments(reference) {
        return await getTrackingShipments(reference).then((response) => {
            return response.entity.jobs;
        }, () => {
            return [];
        });
    },
    async removeCarrier(id) {
        const getErrorMsg = (slug) => {
            switch (slug) {
                case 'NOT_FOUND':
                    return i18next.t('SHIPMENT_NOT_FOUND');
                case 'INVALID_TRANSITION':
                    return i18next.t('CARRIER_REMOVE_INVALID_TRANSITION');
                case 'SHIPMENT_STATE_NOT_ALLOWED':
                    return i18next.t('CARRIER_REMOVE_SHIPMENT_STATE_NOT_ALLOWED');
                default:
                    return i18next.t('CARRIER_REMOVE_ERROR_DEFAULT');
            }
        };
        const result = await removeCarrier(id).catch((result) => {
            showToast('Failed to remove carrier', getErrorMsg(result.entity.error), 'error');
            return null;
        });
        if (result) {
            showToast(i18next.t('CARRIER_REMOVE_SUCCESS'), i18next.t('CARRIER_REMOVE_SUCCESS'), 'success');
            return result.entity.shipment;
        }
        return null;
    },
    getShipmentsById(shipments) {
        getShipmentsLegacy(shipments).then((response) => AdminServerActionCreators.getShipmentsById(response.entity.items), (e) => console.error('Failed to retrieve shipments: ', e));
    },
    getShipmentsForBulkLFD(shipments) {
        getLFDShipments(shipments).then((response) => {
            var _a;
            return AdminServerActionCreators.getShipmentsForBulkLFD((_a = response === null || response === void 0 ? void 0 : response.entity) === null || _a === void 0 ? void 0 : _a.items);
        }, (e) => console.error('Failed to retrieve shipments: ', e));
    },
    bulkTransitionShipmentsToArrived(body) {
        bulkTransitionShipmentsToArrived(body).then((response) => AdminServerActionCreators.receiveBulkTransitionShipmentsSuccess(response.entity), (response) => AdminServerActionCreators.receiveBulkTransitionShipmentsSuccess(response.entity));
    },
    bulkUpdateDates(body) {
        bulkUpdateDates(body).then((response) => AdminServerActionCreators.bulkUpdateDatesSuccess(response.entity), (e) => AdminServerActionCreators.bulkUpdateDatesFail(e));
    },
    async createShipmentsAndTemplate(orderId, name, request) {
        return await createShipmentsAndTemplate(orderId, name, request).then((res) => {
            return res.entity;
        }, (e) => {
            throw e;
        });
    },
    async saveTemplateAndBookShipments(orderId, templateId, name, request) {
        return await saveTemplateAndBookShipments(orderId, templateId, name, request).then((res) => {
            return res.entity;
        }, (e) => {
            throw e;
        });
    },
    async getShipmentTemplates(params = {}) {
        return await getShipmentTemplates(params).then((res) => {
            return res.entity;
        }, (e) => {
            throw e;
        });
    },
    async getShipmentTemplate(templateId) {
        return await getShipmentTemplate(templateId).then((res) => {
            return res.entity.template;
        }, (e) => {
            throw e;
        });
    },
    async bookMultipleOrderShipments(orderId, request) {
        return await bookMultipleOrderShipments(orderId, request).then((res) => {
            return res.entity;
        }, (e) => {
            throw e;
        });
    },
    bulkUpdateNotes(body) {
        bulkUpdateNotes(body).then((response) => AdminServerActionCreators.bulkUpdateNotesSuccess(response.entity), (e) => AdminServerActionCreators.bulkUpdateNotesFail(e));
    },
    bulkUpdateSpecialInstructions(body) {
        bulkUpdateSpecialInstructions(body)
            .then((response) => AdminServerActionCreators.bulkUpdateSpecialInstructionsSuccess(response.entity))
            .catch((e) => AdminServerActionCreators.bulkUpdateSpecialInstructionsFail(e));
    },
    bulkUpdateShipments(body) {
        bulkUpdateShipments(body).then((response) => AdminServerActionCreators.bulkUpdateShipmentsSuccess(response.entity), (e) => AdminServerActionCreators.bulkUpdateShipmentsFail(e));
    },
    bulkAddShipmentReferenceNumbers(body) {
        bulkAddShipmentReferenceNumbers(body).then((response) => {
            AdminServerActionCreators.bulkUpdateReferenceSuccess(response.entity);
        }, (e) => AdminServerActionCreators.bulkUpdateShipmentsFail(e));
    },
    updateDeliveryOrderStatus(jobId, body) {
        updateDeliveryOrderStatus(jobId, body).then((response) => AdminServerActionCreators.updateDeliveryOrderStatusSuccess(response), (e) => AdminServerActionCreators.updateDeliveryOrderStatusFail(e));
    },
    async getDriverJobs(jobs) {
        return await getDriverJobs(jobs).then((response) => {
            return response.entity.items;
        }, (error) => {
            throw error;
        });
    },
    async generateCarrier204(job, event) {
        const getErrorMsg = (slug) => {
            switch (slug) {
                case 'MISSING_JOB_ID':
                    return i18next.t('CARRIER_204_MISSING_JOB_ID');
                case 'MISSING_EVENT':
                    return i18next.t('CARRIER_204_MISSING_EVENT');
                default:
                    return i18next.t('CARRIER_204_DEFAULT');
            }
        };
        return await generateCarrier204(job, event).then(() => showToast('Carrier 204', i18next.t('CARRIER_204_GENERATED_SUCCESS')), (result) => showToast('Carrier', getErrorMsg(result.entity.error), 'error'));
    },
    async getShipmentsByShipmentID(referenceNumbers) {
        return await getShipmentsByShipmentID(referenceNumbers).then((response) => {
            return response.entity;
        }, (error) => {
            throw error;
        });
    },
    uploadStopDocuments(shipment, stop, files, signatory) {
        return uploadStopDocuments(shipment, stop, files, signatory).then((response) => {
            return response;
        }, (error) => {
            throw error;
        });
    },
    deleteStopDocumentsV2(shipmentId, stop, documentIds) {
        return deleteStopDocumentsV2(shipmentId, stop, documentIds).then((response) => {
            return response.entity;
        }, (error) => {
            throw error;
        });
    },
    async createBaseCostAdjustments(adjustments) {
        const result = await createBaseCostAdjustments(adjustments).catch((error) => {
            showToast('Shipment', i18next.t('BASE_COST_ADJUSTMENT_FAILURE'), 'error');
            return error;
        });
        const { successCount, errors } = result.entity;
        if (errors === null || errors === void 0 ? void 0 : errors.length) {
            showToast('Partial Success', i18next.t('FAILED_DUE_TO_INVALID_INPUT', {
                count: result.entity.errors.length,
            }), 'error');
        }
        if (successCount) {
            showToast('Shipment', i18next.t('BASE_COST_ADJUSTMENT_SUCCESS', { count: successCount }), 'success');
        }
        return result;
    },
    async createOutgateShipmentStops(jobId, data) {
        try {
            const response = await createOutgateShipmentStops(jobId, data).catch((e) => {
                throw e;
            });
            response.entity.job = transformInboundShipments([response.entity.job])[0];
            AdminServerActionCreators.receiveShipmentSuccess(response.entity);
            showToast('Shipment', i18next.t('ADD_OUTGATE_STOPS_SUCCESS'), 'success');
        }
        catch (e) {
            showToast('Shipment', i18next.t('ADD_OUTGATE_STOPS_ERROR'), 'error');
            return e;
        }
    },
    async splitShipment(jobId, data) {
        try {
            const response = await splitShipment(jobId, data).catch((e) => {
                throw e;
            });
            return response.entity;
        }
        catch (e) {
            const { entity: { error }, } = e;
            console.log(e);
            showToast('Shipment', error, 'error');
            return e;
        }
    },
    async getShipmentsLedgers(jobIds, ledgerType) {
        try {
            const response = await getShipmentsLedgers(jobIds, ledgerType).catch((e) => {
                throw e;
            });
            return response.entity;
        }
        catch (e) {
            showToast('Shipment', i18next.t('JOB_INFO_RETRIEVAL_ERROR'), 'error');
            return e;
        }
    },
    async generateAndSendBulkRateConfirmation(data) {
        try {
            const response = await generateAndSendBulkRateConfirmation(data).catch((e) => {
                throw e;
            });
            return response.entity;
        }
        catch (e) {
            showToast('Shipment', i18next.t('BULK_RATE_CONFIRMATION_API_ERROR'), 'error');
            return e;
        }
    },
    async sendFeesDuePaymentLink(jobId, emails) {
        try {
            const response = await sendFeesDuePaymentLink(jobId, emails).catch((e) => {
                throw e;
            });
            const { entity } = response;
            if (entity && entity.success) {
                const message = entity.sent
                    ? i18next.t('SUCCESSFULLY_SENT_FEES_DUE_LINK')
                    : i18next.t('NO_FEES_DUE_CURRENTLY');
                showToast('Shipment', message, 'success');
                return entity;
            }
            throw new Error('ERROR_SENDING_FEES_DUE_PAYMENT_LINK');
        }
        catch (e) {
            showToast('Shipment', i18next.t('ERROR_SENDING_FEES_DUE_PAYMENT_LINK'), 'error');
            throw e;
        }
    },
    async getMissingReferenceNumbers(job, stage = null) {
        try {
            const { entity } = await getMissingReferenceNumbers(job, stage);
            if (!(entity === null || entity === void 0 ? void 0 : entity.success)) {
                throw new Error('ERROR_GETTING_MISSING_REFERENCE_NUMBERS');
            }
            return entity;
        }
        catch (e) {
            showToast('Shipment', i18next.t('ERROR_GETTING_MISSING_REFERENCE_NUMBERS'), 'error');
            throw e;
        }
    },
    async getMissingReferenceNumbersList(job, stage) {
        try {
            const { entity } = await getMissingReferenceNumbersList(job, stage);
            if (!(entity === null || entity === void 0 ? void 0 : entity.success)) {
                throw new Error('ERROR_GETTING_MISSING_REFERENCE_NUMBERS_LIST');
            }
            return entity;
        }
        catch (e) {
            showToast('Shipment', i18next.t('ERROR_GETTING_MISSING_REFERENCE_NUMBERS_LIST'), 'error');
            throw e;
        }
    },
    async getMissingReferenceNumbersAtBookingTime(job) {
        try {
            const { entity } = await getMissingReferenceNumbersAtBookingTime(job);
            if (!(entity === null || entity === void 0 ? void 0 : entity.success)) {
                throw new Error('ERROR_GETTING_MISSING_REFERENCE_NUMBERS');
            }
            return entity;
        }
        catch (e) {
            showToast('Shipment', i18next.t('ERROR_GETTING_MISSING_REFERENCE_NUMBERS'), 'error');
            throw e;
        }
    },
    async shipperAssignCarrier(carrierId, shipmentIds, isNetworkCarrier) {
        try {
            const data = {
                carrierId,
                shipmentIds,
                isNetworkCarrier,
            };
            const response = await shipperAssignCarrier(data);
            showToast('Shipment', 'SHIPMENTS_ASSIGNED_SUCCESSFULLY', 'success');
            return response;
        }
        catch (e) {
            showToast('Shipment', i18next.t('ERROR_ASSIGNING_CARRIER'), 'error');
            throw e;
        }
    },
    updateCustomLfd(shipment, custom_lfd) {
        updateShipmentHandler(shipment, { custom_lfd });
    },
};
export function shipperAssignCarrier(data) {
    return client({
        method: 'POST',
        path: `/api/customers/jobs/assign`,
        entity: JSON.stringify(data),
    });
}
export function resendEDIInvoices({ invoice_numbers, events }) {
    return client({
        method: 'POST',
        path: `/admin/api/edi-resend/invoices`,
        entity: JSON.stringify({ invoice_numbers, events }),
    });
}
export function resendEDIInvoicesBulk({ file }) {
    return new Promise((resolve, reject) => {
        request
            .post(`${API_HOST}/admin/api/edi-resend/invoices/bulk`)
            .set('Authorization', getBearerGrantTypeAuthHeaders())
            .attach('bulk_edi_resend_csv', file)
            .end((err, res) => {
            if (err) {
                reject(err);
            }
            else {
                resolve(res);
            }
        });
    });
}
export function resendEDIShipmentMilestones({ reference_numbers, events }) {
    return client({
        method: 'POST',
        path: `/admin/api/edi-resend/milestones`,
        entity: JSON.stringify({ reference_numbers, events }),
    });
}
export function resendEDIShipmentMilestonesBulk({ file, events }) {
    return new Promise((resolve, reject) => {
        request
            .post(`${API_HOST}/admin/api/edi-resend/milestones/bulk`)
            .set('Authorization', getBearerGrantTypeAuthHeaders())
            .field('events[]', events)
            .attach('bulk_edi_resend_csv', file)
            .end((err, res) => {
            if (err) {
                reject(err);
            }
            else {
                resolve(res);
            }
        });
    });
}
export function resendCarrierEdiEvents({ reference_numbers, events, targetCarriers, }) {
    return client({
        method: 'POST',
        path: `/admin/api/edi-resend/carriers`,
        entity: JSON.stringify({ reference_numbers, events, targetCarriers }),
    });
}
export function resendEDICarrierEventsBulk({ file, events, targetCarriers }) {
    return new Promise((resolve, reject) => {
        request
            .post(`${API_HOST}/admin/api/edi-resend/carriers/bulk`)
            .set('Authorization', getBearerGrantTypeAuthHeaders())
            .field('events[]', events)
            .field('targetCarriers', targetCarriers)
            .attach('bulk_edi_resend_csv', file)
            .end((err, res) => {
            if (err) {
                reject(err);
            }
            else {
                resolve(res);
            }
        });
    });
}
export function runPrecheck({ userType, referenceNumbers, events, targetCarriers, }) {
    const queryString = qs.stringify({
        userType,
        referenceNumbers,
        events,
        targetCarriers,
    });
    return client({
        method: 'GET',
        path: `/admin/api/edi-resend/check-request?${queryString}`,
    });
}
export function getFileStatus(fileStatusID) {
    return client({
        method: 'GET',
        path: `/admin/api/jobs/file-status/${fileStatusID}`,
    });
}
export function createBulkShipments(data) {
    return client({
        method: 'POST',
        path: `/admin/api/jobs/file-status`,
        entity: JSON.stringify(data),
    });
}
export function validateShipments(data) {
    return client({
        method: 'POST',
        path: `/admin/api/jobs/bulk/validate`,
        entity: JSON.stringify(data),
    });
}
export const getNextSteps = (jobID) => {
    return client({
        method: 'GET',
        path: `/api/jobs/${jobID}/next-actions`,
    });
};
export const evaluateBillingStatus = (shipmentIds) => {
    return client({
        method: 'POST',
        path: '/admin/jobs/evaluate/billing/status',
        entity: JSON.stringify({ shipmentIds }),
    });
};
export const evaluateBillingStatusByReferenceNumbers = ({ shipmentReferences, forcePauseBillStatusEvaluation, }) => {
    return client({
        method: 'POST',
        path: '/admin/jobs/evaluate/billing/status',
        entity: JSON.stringify({
            shipmentReferences,
            force_paused_bill_status_evaluation: forcePauseBillStatusEvaluation,
        }),
    });
};
export const bulkCloseJobs = (shipmentIds) => {
    return client({
        method: 'POST',
        path: '/admin/api/v3/jobs/bulk/close',
        entity: JSON.stringify({ shipmentIds }),
    });
};
export const overrideBillingStatus = (request, orderId = null) => {
    if (orderId) {
        return client({
            method: 'PUT',
            path: `/admin/api/orders/${orderId}/billing/status`,
            entity: JSON.stringify(request),
        });
    }
    return client({
        method: 'POST',
        path: '/admin/api/billing/status/override',
        entity: JSON.stringify(request),
    });
};
export const bulkOverrideOrderBillingStatus = (request) => client({
    method: 'POST',
    path: '/admin/api/orders/bulk/billing/status',
    entity: JSON.stringify(request),
});
export const refreshOrderBillingStatus = (orderId) => {
    return client({
        method: 'POST',
        path: `/admin/api/orders/${orderId}/billing/status/refresh`,
    });
};
AdminAppDispatcher.register((payload) => {
    const action = payload.action || {};
    const type = action.type;
    switch (type) {
        case ActionTypes.CREATE_ORDER_SHIPMENT_REQUEST:
            API.createOrderShipment(action.offer);
            break;
        case ActionTypes.CREATE_QUOTE_REQUEST:
            API.createQuote(action.quote);
            break;
        case ActionTypes.UPDATE_QUOTE_REQUEST:
            API.updateQuote(action.quote);
            break;
        case ActionTypes.DELETE_QUOTE_REQUEST:
            API.deleteQuote(action.quoteId);
            break;
        case ActionTypes.REMOVE_CARRIER:
            API.removeCarrier(action.job, action.update);
            break;
        case ActionTypes.BULK_UPDATE_CARRIER_COSTS_REQUEST:
            API.bulkUpdateCarrierCosts(action.updates);
            break;
        default:
            break;
    }
});
export default API;
